// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:36:39.015Z
// Property: Shadow Ridge Apts. (ID: 6767906449165624)
// Collections: 35 amenities, 9 floorplans (live), 41 photos, 52 POIs, 1 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165624",
  "property_external_id": "0yr6c72",
  "property_zillow_url": "https://www.zillow.com/apartments/el-paso-tx/shadow-ridge-apts./5XrZ65/",
  "property_apartments_url": "https://www.apartments.com/shadow-ridge-apts-el-paso-tx/0yr6c72/",
  "property_google_business_url": "https://www.google.com/maps/place/Shadow+Ridge+Apartments/data=!4m2!3m1!1s0x0:0xdb27f91de7843774?sa=X&ved=2ahUKEwj_mvGE_7ySAxVJjokEHS3lNYUQ_BJ6BAg8EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40342481553",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "shadow-ridge-apts.",
  "property_name": "Shadow Ridge Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/shadow-ridge-apts/",
  "property_domain": null,
  "property_address": "9375 Viscount Blvd.",
  "property_full_address": "9375 Viscount Blvd., El Paso, TX, 79925",
  "property_address_1": "9375 Viscount Blvd.",
  "property_address_2": null,
  "property_address_city": "El Paso",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79925",
  "property_address_country": "US",
  "property_address_county": "El Paso",
  "property_neighborhood_address": "Stonehaven",
  "property_address_latitude": "31.7701",
  "property_address_longitude": "-106.3629",
  "property_email": "shadowridge@caseusa.com",
  "property_phone": "(915) 615-1984",
  "property_call_tracking_phone": "833-713-4146",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Shadow Ridge Apts. in El Paso, Texas, enjoy a range of stylish floor plans from cozy studios to spacious three-bedrooms. Dive into luxury amenities like a sparkling pool, modern fitness center, and pet-friendly spaces. Embrace comfort, convenience, and community—secure your ideal home today and schedule a tour! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Shadow Ridge Apartments, your urban oasis in the heart of El Paso, Texas! Our vibrant community offers a diverse selection of floor plans, including charming studios, spacious one, two, and three-bedroom apartments designed to fit your lifestyle. With our array of modern amenities, you'll find everything you need to live comfortably and conveniently.\n\nDive into relaxation at our sparkling pool, stay active in our fully-equipped fitness center, and enjoy the ease of on-site laundry facilities. For those who prefer a furnished living space, we offer beautifully appointed units that make moving in a breeze. Our community is pet-friendly, featuring a dedicated pet washing station to keep your furry friends happy.\n\nStay connected easily with complimentary Wi-Fi and 24-hour maintenance services. Our property manager is always on-site to assist you, ensuring a seamless living experience. Enjoy access to our business center, clubhouse, and inviting picnic area complete with grills, perfect for weekend gatherings. For recreation, you can take advantage of our playground and volleyball court.\n\nEach apartment is designed with your comfort in mind, featuring air conditioning, high-speed internet access, walk-in closets, and modern kitchens equipped with microwaves, dishwashers, and pantries. Many units also boast balconies and patios for delightful outdoor living.\n\nAt Shadow Ridge Apartments, we're dedicated to creating a smoke-free, welcoming environment where you can relax and unwind. Don't miss out on the opportunity to call our community home. Find your new apartment today—browse our availability or schedule a tour to experience the charm of Shadow Ridge firsthand!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-712b-700a-91e8-9ce9ee86730f.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and a covered cabana.",
    "public_id": "019cfb47-712b-700a-91e8-9ce9ee86730f",
    "storage_key": "property/6767906449165624/019cfb47-712b-700a-91e8-9ce9ee86730f.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "352",
  "property_year_built": "1994",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.875",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "We allow up to two pets per unit (dogs and cats). No weight limit.",
  "property_pet_policy_description": "Above applies to any pet",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://shadowridgeapartmentselpaso.securecafe.com/onlineleasing/shadow-ridge-apts/floorplans.aspx",
  "property_resident_portal_url": "https://shadowridgeapartmentselpaso.securecafe.com/residentservices/shadow-ridge-apts/userlogin.aspx",
  "property_apply_now_url": "https://shadowridgeapartmentselpaso.securecafe.com/onlineleasing/shadow-ridge-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb46-cf87-704d-9895-15b861364cdb.webp",
  "property_primary_logo_media": {
    "alt_text": "Shadow Ridge Apartments logo",
    "public_id": "019cfb46-cf87-704d-9895-15b861364cdb",
    "storage_key": "property/6767906449165624/019cfb46-cf87-704d-9895-15b861364cdb.webp",
    "width": 300,
    "height": 158
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-faaf-7320-9a52-ae45191896f6.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb47-faaf-7320-9a52-ae45191896f6",
    "storage_key": "property/6767906449165624/019cfb47-faaf-7320-9a52-ae45191896f6.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb48-1bb9-7298-b999-6abfb167cb7c.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Shadow Ridge Apartments logo",
    "public_id": "019cfb48-1bb9-7298-b999-6abfb167cb7c",
    "storage_key": "property/6767906449165624/019cfb48-1bb9-7298-b999-6abfb167cb7c.webp",
    "width": 300,
    "height": 158
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb48-238d-7737-b2e6-700007b9c9ab.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Shadow Ridge Apartments logo",
    "public_id": "019cfb48-238d-7737-b2e6-700007b9c9ab",
    "storage_key": "property/6767906449165624/019cfb48-238d-7737-b2e6-700007b9c9ab.webp",
    "width": 300,
    "height": 158
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#4f4842",
  "property_secondary_color": "#dfd9cf",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#beb5a9",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "457 - 954",
  "property_sqft_min": "457",
  "property_sqft_max": "954",
  "property_price_range": "844 - 1410",
  "property_price_min": "844",
  "property_price_max": "1410",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/valley.ridgeapts/",
  "property_instagram_url": "https://www.instagram.com/valleyridgeapartments/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJAQiecTtb54YRdDeE5x35J9s",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/valley-ridge-apartments-el-paso",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Shadow Ridge Apts.",
  "property_home_romance_title": "Experience the Heartfelt Comfort of Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Shadow Ridge Apts. in El Paso, where comfort meets convenience. Choose from spacious floor plans—ideal for every lifestyle. Enjoy a refreshing pool, modern fitness center, and pet-friendly amenities, all while relishing the charm of home. Experience a vibrant lifestyle with us today—your oasis awaits!",
  "property_home_floorplans_blurb": "At Shadow Ridge Apts. in vibrant El Paso, Texas, find the ideal space for your lifestyle, whether you’re seeking a cozy studio or a spacious three-bedroom. Each thoughtfully designed floor plan offers comfort and style. Browse our available apartment homes today and unlock your next chapter!",
  "property_home_gallery_blurb": "Welcome to Shadow Ridge Apartments in sunny El Paso, Texas, where comfort meets convenience. Choose your perfect space, from stylish studios to spacious three-bedrooms. Enjoy resort-style amenities like a refreshing pool, pet washing station, and vibrant clubhouse. Picture yourself living here, surrounded by everything you need for a fulfilling lifestyle!",
  "property_home_neighborhood_blurb": "Welcome to Shadow Ridge Apts., your gateway to vibrant El Paso living! Nestled near cultural gems like the Archaeology and History Museum of El Chamizal and the El Paso Zoo, our community offers a charming blend of comfort and convenience. Enjoy spacious floor plans tailored for every lifestyle. Uncover the richness around you!",
  "property_home_reviews_blurb": "At Shadow Ridge Apartments in El Paso, experience a worry-free lifestyle with friendly staff and quick maintenance. Our residents rave about our amenities, like the inviting pools and pet-friendly policies, noting, “...Stone Ridge Apartments have taken me over the rainbow.” See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Shadow Ridge Apts. in vibrant El Paso, our community thrives amidst rich cultural landmarks and recreational hotspots. Enjoy proximity to the El Paso Zoo and Botanical Gardens, the Archaeology and History Museum of El Chamizal, and lush parks like Memorial Park. Uncover the essence of local living right outside your door!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Shadow Ridge Apts. in El Paso, Texas, experience vibrant living with outstanding amenities including a sparkling pool, fitness center, and pet washing station. Choose from a variety of thoughtfully designed floor plans—from cozy studios to spacious three-bedroom units—perfect for your lifestyle. Comfort and convenience await!",
  "property_applynow_blurb": "At Shadow Ridge Apts. in El Paso, Texas, your ideal living space awaits! Choose from a variety of floor plans, including cozy studios and spacious three-bedroom units. Enjoy exquisite amenities such as a sparkling pool, fitness center, and even a pet washing station. Lease your new home online today!",
  "property_contactus_blurb": "At Shadow Ridge Apts. in sunny El Paso, Texas, we offer a variety of floor plans to suit your lifestyle—from cozy studios to spacious three-bedroom options. Our leasing team is ready to answer all your questions and help you find your perfect home here. Reach out today!",
  "property_faqs_blurb": "At Shadow Ridge Apts. in vibrant El Paso, Texas, we offer a range of living options, from cozy studios to spacious three-bedroom layouts. Curious about our community? Delve into our FAQs page for insights into your future home, whether you're a solo dweller or a family of five!",
  "property_floorplans_blurb": "Welcome to Shadow Ridge Apts. in vibrant El Paso, Texas, where comfort meets style. Choose from our thoughtfully designed floor plans, including cozy studios, spacious one, two, and three-bedroom options. Each layout offers a unique living experience. Browse our available apartment homes and find the perfect space for your lifestyle.",
  "property_gallery_blurb": "At Shadow Ridge Apts. in vibrant El Paso, Texas, our diverse floor plans—from cozy studios to spacious three-bedrooms—complement a lifestyle enriched with amenities. Imagine sunny days by the pool, fitness sessions in our center, or unwinding in your beautifully furnished unit. Picture yourself living here!",
  "property_interactivemap_blurb": "At Shadow Ridge Apartments in El Paso, Texas, your perfect home awaits! Choose from a variety of thoughtfully designed floor plans, from studios to spacious three-bedrooms. Enjoy remarkable amenities like a refreshing pool, cutting-edge fitness center, and a cozy clubhouse. Utilize our interactive community map to find your ideal space!",
  "property_pets_blurb": "At Shadow Ridge Apts. in vibrant El Paso, Texas, your furry companions are part of the family! Enjoy a pet-friendly haven, where up to two pets—no weight limits—are welcomed with open arms. Create unforgettable memories with your pets in a community that truly understands the joy they bring.",
  "property_referafriend_blurb": "At Shadow Ridge Apts. in El Paso, Texas, our diverse floor plans—from cozy studios to spacious three-bedroom retreats—cater to every lifestyle. Share the joy of our welcoming community with friends. Refer a friend today and enrich your living experience; great friends truly make the best neighbors!",
  "property_residentaccess_blurb": "Welcome to Shadow Ridge Apts. in vibrant El Paso, Texas! Our community offers diverse floor plans, from cozy studios to spacious three-bedroom apartments, designed for every lifestyle. Access your resident portal for easy rent payment, maintenance requests, and more—because your convenience is our priority. Join us at Shadow Ridge today!",
  "property_reviews_blurb": "At Shadow Ridge Apartments in El Paso, residents feel at home with our friendly staff and quick maintenance. With amenities like two pools and a charming park, you can relax while we take care of the details. As one resident puts it, \"I couldn't be happier\" in this serene community.",
  "property_created_at": "1753982390944",
  "property_scheduletour_blurb": "Experience life at Shadow Ridge Apts., where comfort meets style in El Paso, Texas. With versatile floor plans, including studios, and one to three-bedroom apartments, our community caters to every lifestyle. Schedule a tour today and hear firsthand why our residents love calling Shadow Ridge home!",
  "property_thankyou_blurb": "Thank you for reaching out! At Shadow Ridge Apts. in El Paso, TX, you’ll find a variety of thoughtfully designed floor plans—studio, one, two, and three-bedroom options—to suit your lifestyle. Our team will be in touch soon to help you discover your perfect home!",
  "property_virtualtours_blurb": "Experience the charm of Shadow Ridge Apts. in El Paso, Texas, where comfort meets style. From cozy studios to spacious three-bedroom layouts, our diverse floor plans cater to all lifestyles. Step into your future home today—take a virtual tour of our vibrant community and apartments for rent!",
  "property_copyright": "2025 All Rights Reserved. Shadow Ridge Apts.",
  "property_seo_title_home": "Shadow Ridge Apts. |  Apartments in El Paso, Texas",
  "property_seo_description_home": "Experience modern living at Shadow Ridge Apts. in El Paso! Choose from stylish floor plans and enjoy top-notch amenities like pools, fitness centers, and more!",
  "property_seo_title_floorplans": "Floor Plans | El Paso, Texas Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Shadow Ridge Apts. in El Paso! Choose from stylish studios to spacious three-bedroom homes. Your perfect floor plan awaits!",
  "property_seo_title_amenities": "Amenities | El Paso, Texas Apartments for Rent",
  "property_seo_description_amenities": "Experience vibrant living at Shadow Ridge Apts. in El Paso! Enjoy a pool, fitness center, and cozy clubhouse with diverse floor plans.",
  "property_seo_title_gallery": "Gallery | Apartments in El Paso, Texas",
  "property_seo_description_gallery": "Picture life at Shadow Ridge Apts. in El Paso! Stunning photo gallery showcasing spacious layouts, vibrant amenities, and your future home. Dive in!",
  "property_seo_title_virtualtours": "Virtual Tours | Shadow Ridge Apts. Apartments",
  "property_seo_description_virtualtours": "Step inside Shadow Ridge Apts. in El Paso with our virtual tour! View stunning floor plans from studios to three-bedrooms and find your perfect home today.",
  "property_seo_title_interactivemap": "Interactive Map | Shadow Ridge Apts. Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Shadow Ridge Apts. in El Paso! Explore floor plans, pricing, and amenities like a pool and fitness center.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in El Paso, Texas",
  "property_seo_description_neighborhood": "Uncover the vibrant El Paso lifestyle at Shadow Ridge Apts. Dive into local favorites and explore the best our neighborhood has to offer just steps from home.",
  "property_seo_title_contact": "Contact Us | Shadow Ridge Apts.",
  "property_seo_description_contact": "Reach out to our leasing team at Shadow Ridge Apts. in El Paso! Explore your ideal floor plan—studio to three-bedroom. We’re here to help with your questions!",
  "property_seo_title_faqs": "FAQs | Apartments in El Paso, Texas",
  "property_seo_description_faqs": "Find answers to your questions about Shadow Ridge Apts. in El Paso, TX. Our FAQs cover everything from amenities to leasing. Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in El Paso, Texas",
  "property_seo_description_reviews": "Experience life at Shadow Ridge Apts. in El Paso! Check out what our residents say about our vibrant community full of amenities and spacious floor plans.",
  "property_seo_title_applynow": "Apply Now | Apartments in El Paso, Texas",
  "property_seo_description_applynow": "Experience luxury living at Shadow Ridge Apts. in El Paso! From spacious layouts to premium amenities, your perfect home awaits. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Shadow Ridge Apts.",
  "property_seo_description_residentaccess": "Unlock your convenience at Shadow Ridge Apts. in El Paso! Access your resident portal for rent payments, maintenance requests, and essential community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Shadow Ridge Apts.",
  "property_seo_description_referafriend": "Great friends make great neighbors at Shadow Ridge Apts. in El Paso! Refer a friend today and share the joy of our vibrant apartment community.",
  "property_seo_title_scheduletour": "Schedule a Tour | Shadow Ridge Apts.",
  "property_seo_description_scheduletour": "Experience El Paso living at Shadow Ridge Apts.! Schedule your tour today and find your perfect home where comfort meets community in a vibrant setting.",
  "property_seo_title_privacy": "Privacy Policy | Shadow Ridge Apts.",
  "property_seo_description_privacy": "Unveil the peace of mind at Shadow Ridge Apts. in El Paso, TX. Your privacy matters to us—check out our comprehensive policy for total reassurance.",
  "property_seo_title_accessibility": "Website Accessibility | Shadow Ridge Apts.",
  "property_seo_description_accessibility": "At Shadow Ridge Apts. in El Paso, we prioritize accessibility and digital inclusion, ensuring everyone can experience our vibrant community. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Shadow Ridge Apts.",
  "property_seo_description_sitemap": "Uncover every corner of Shadow Ridge Apts. in El Paso, TX! Navigate our sitemap for easy access to amenities, floor plans, and community info.",
  "property_seo_title_thankyou": "Thank You | Shadow Ridge Apts.",
  "property_seo_description_thankyou": "Thank you for reaching out to Shadow Ridge Apts. in El Paso! Your inquiry is important to us—expect a friendly team member to connect with you soon.",
  "property_seo_title_pets": "Pet Policy | Apartments in El Paso, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865734777",
  "amenities": [
    {
      "id": "ec_dfc4707da1e77c1c7683f5eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397092",
      "title": "Spanish Speaking Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ddc0d10df3c70e18489ad0c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397093",
      "title": "Short Term Lease",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e1cfb75535b41166227e551",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397094",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42d596d59e0c00603484a185",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397095",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4b08e59083ca8a0dc318f76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397096",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0d2c5b15b7965b20804ac34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397097",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b6f5848791c914ad663ae63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397098",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc80aae45c5c2d6aba742b0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397099",
      "title": "Easy Access to I-10",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6acbc4a6682ea49759157035",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397100",
      "title": "Ideal Location Near Fort Bliss",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48aff04fe1fa5a2d9b585e8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397101",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_408386a1609a6af705906194",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397102",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c3426cdf7e7301911c68dcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397103",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4272667ddfd855594a35b6f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397104",
      "title": "Onsite Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59b71ca7555b95613f93bf60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397105",
      "title": "Corporate Apartments Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e3ff413fe39ff4ce651993b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397106",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9576c55cdad288856779b91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397107",
      "title": "Package Receiving Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87e2235873837bae764d8ea8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397108",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b04d0953af71dcdd94409f6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397109",
      "title": "Onsite Pet Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aff4bc95e9a366f10e7ee763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127397110",
      "title": "Electronic Payments Accepted",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d504b42838e15dc5c832681",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "128042519",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce45a17240bfadaf2d342d2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398558",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c6538c480e82d32fc34c9793",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398559",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5539880127123b1ee5eebed0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398560",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b5d7e9933a06e10d9cfb66bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398561",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8692c51644730af5d40db740",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398562",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c59b3928adb552eec44442e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398563",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22c8201f0ff28bb73eb11fcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398564",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f5c25919d4b93da9c73c88d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398565",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71bf31d7e512f95347692126",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398566",
      "title": "Built-In Bookshelves*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5da7a16607763431796edf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398567",
      "title": "Reliable Cell Reception",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00a86888921dbcfc7da27233",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398568",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aee0c238ce51fd08878a49a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398569",
      "title": "Roommate Friendly Floorplan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3fe327c701082bf626dbec9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398570",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8fdc7aca0653dc368630e54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398571",
      "title": "Wheelchair Access*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a6a2e6cfc803f14ffabba30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "yardi",
      "external_id": "127398572",
      "title": "Get connected to super fast internet powered by AT&T",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_84d29492-0a22-4847-ba02-c5d2e4c0b9ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db075-45dd-75a7-84bb-dd69126c7443.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, ceiling fan, and balcony access.",
        "public_id": "019db075-45dd-75a7-84bb-dd69126c7443",
        "storage_key": "property/6767906449165624/019db075-45dd-75a7-84bb-dd69126c7443.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed, a ceiling fan, and a balcony door. The room is decorated with modern accents and warm lighting.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, ceiling fan, and balcony access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_30fae32a-108b-4a55-936a-e599d7fd6ace",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db075-37d2-75fb-ae98-e5e395d0bb5f.webp",
      "image_media": {
        "alt_text": "Living room with a decorative chair, a desk with a highland cow painting, and a sofa.",
        "public_id": "019db075-37d2-75fb-ae98-e5e395d0bb5f",
        "storage_key": "property/6767906449165624/019db075-37d2-75fb-ae98-e5e395d0bb5f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed living room, perfect for unwinding after a long day or hosting guests. Features a stylish armchair, a functional desk space, and comfortable sofa seating.",
      "link": "",
      "alt_text": "Living room with a decorative chair, a desk with a highland cow painting, and a sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bbf32920-ed84-44c2-8e17-e92d51ccd5d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db075-3aec-73dc-a816-5c5385f6bef3.webp",
      "image_media": {
        "alt_text": "Modern living room with a desk and chair, a patterned armchair, and a dining area.",
        "public_id": "019db075-3aec-73dc-a816-5c5385f6bef3",
        "storage_key": "property/6767906449165624/019db075-3aec-73dc-a816-5c5385f6bef3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore this stylish apartment featuring a dedicated workspace, comfortable seating, and a dining nook, perfect for modern living.",
      "link": "",
      "alt_text": "Modern living room with a desk and chair, a patterned armchair, and a dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7ca825d6-873a-437e-8a9b-4b0478662cfe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db075-3bdf-7377-b54d-54138a824d8c.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, vanity, and mirror.",
        "public_id": "019db075-3bdf-7377-b54d-54138a824d8c",
        "storage_key": "property/6767906449165624/019db075-3bdf-7377-b54d-54138a824d8c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom featuring a bathtub with a patterned shower curtain, a double vanity with a marble countertop, and decorative vases.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, vanity, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ae40d6e-2c52-4a7a-b326-b9d32f29e034",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db075-2ef7-73fe-9af8-e0d6aa68847a.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, sloth and llama art, and a large window.",
        "public_id": "019db075-2ef7-73fe-9af8-e0d6aa68847a",
        "storage_key": "property/6767906449165624/019db075-2ef7-73fe-9af8-e0d6aa68847a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed, decorative sloth and llama artwork, and a spacious window offering a view of the community.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, sloth and llama art, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_60a44392-72b2-4986-bb59-073ef0d4acb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db075-309d-7482-bdaa-49c9a0d3daac.webp",
      "image_media": {
        "alt_text": "Closet with hanging clothes and storage bins",
        "public_id": "019db075-309d-7482-bdaa-49c9a0d3daac",
        "storage_key": "property/6767906449165624/019db075-309d-7482-bdaa-49c9a0d3daac.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious closet with ample shelving and storage solutions, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Closet with hanging clothes and storage bins",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_93f50f20-62f7-46f5-bed4-9de3105f9d17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db075-1fa0-7598-b2ce-8d6be1a3c372.webp",
      "image_media": {
        "alt_text": "Queen bed with white bedding and pink stripes, a blue throw blanket, and decorative pillows. A wooden nightstand with a lamp and a dresser are also visible.",
        "public_id": "019db075-1fa0-7598-b2ce-8d6be1a3c372",
        "storage_key": "property/6767906449165624/019db075-1fa0-7598-b2ce-8d6be1a3c372.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom featuring a queen-size bed with plush linens and decorative pillows. A spacious wooden dresser and nightstand provide ample storage.",
      "link": "",
      "alt_text": "Queen bed with white bedding and pink stripes, a blue throw blanket, and decorative pillows. A wooden nightstand with a lamp and a dresser are also visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df4fc1ef-ddce-4e00-b560-fcb043ece330",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db075-21f9-7185-acdf-6dcdfd4df7e6.webp",
      "image_media": {
        "alt_text": "Bright bathroom with a vanity, toilet, and bathtub with shower.",
        "public_id": "019db075-21f9-7185-acdf-6dcdfd4df7e6",
        "storage_key": "property/6767906449165624/019db075-21f9-7185-acdf-6dcdfd4df7e6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Freshen up in this bright bathroom, featuring a vanity, toilet, and a bathtub with shower. The \"Good Vibes\" decor adds a cheerful touch.",
      "link": "",
      "alt_text": "Bright bathroom with a vanity, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_029a9be1-2328-430e-82a1-f20f79f8bebc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db075-2288-709c-a4d8-b5e05537117c.webp",
      "image_media": {
        "alt_text": "Interior view of a laundry area with a window, washing machine hookups, and pet bowls.",
        "public_id": "019db075-2288-709c-a4d8-b5e05537117c",
        "storage_key": "property/6767906449165624/019db075-2288-709c-a4d8-b5e05537117c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This laundry room is equipped with a window for natural light, convenient hookups for a washer and dryer, and feeding bowls, making it a pet-friendly space.",
      "link": "",
      "alt_text": "Interior view of a laundry area with a window, washing machine hookups, and pet bowls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c9f11a4-fc84-4ff4-a261-ff2aea11b71a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db075-1f7b-74da-a68a-d25a101ba71a.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wood cabinets, and dual sink.",
        "public_id": "019db075-1f7b-74da-a68a-d25a101ba71a",
        "storage_key": "property/6767906449165624/019db075-1f7b-74da-a68a-d25a101ba71a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring white appliances, ample cabinet space, and a convenient dual sink area, perfect for everyday cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen with white appliances, wood cabinets, and dual sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_12810ca6-4e7f-4a43-8283-a010adfc10a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db075-119c-765e-9b35-c8ef7a2af250.webp",
      "image_media": {
        "alt_text": "Kitchen island with two stools and a view into the kitchen area with a refrigerator and microwave.",
        "public_id": "019db075-119c-765e-9b35-c8ef7a2af250",
        "storage_key": "property/6767906449165624/019db075-119c-765e-9b35-c8ef7a2af250.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living and dining space with a convenient kitchen island, perfect for casual meals or entertaining guests.",
      "link": "",
      "alt_text": "Kitchen island with two stools and a view into the kitchen area with a refrigerator and microwave.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f60ef012-50a1-4df1-9059-4ccfbbce4f87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db075-0333-7328-93d6-b07350686d0c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and spa with waterfalls next to a brick building.",
        "public_id": "019db075-0333-7328-93d6-b07350686d0c",
        "storage_key": "property/6767906449165624/019db075-0333-7328-93d6-b07350686d0c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautiful outdoor swimming pool and spa, featuring cascading waterfalls and ample lounging space.",
      "link": "",
      "alt_text": "Outdoor swimming pool and spa with waterfalls next to a brick building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e671d385-4d42-4b56-ade4-1e05067943f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db074-f173-74b9-bff0-29d657edb362.webp",
      "image_media": {
        "alt_text": "Exterior view of brick apartment buildings with balconies and parking lot.",
        "public_id": "019db074-f173-74b9-bff0-29d657edb362",
        "storage_key": "property/6767906449165624/019db074-f173-74b9-bff0-29d657edb362.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring brick accents, balconies, and a spacious parking lot.",
      "link": "",
      "alt_text": "Exterior view of brick apartment buildings with balconies and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_569713c8-4f4b-4241-ac0c-a76c00159f44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db074-f5d2-7265-826c-8c9ffe697333.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019db074-f5d2-7265-826c-8c9ffe697333",
        "storage_key": "property/6767906449165624/019db074-f5d2-7265-826c-8c9ffe697333.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and shaded areas for your enjoyment.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_303140c2-b755-41ad-9ffe-d218742e6948",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db074-f379-74cb-8a39-9b18705dbccd.webp",
      "image_media": {
        "alt_text": "Dog park with benches, waste station, and walking paths",
        "public_id": "019db074-f379-74cb-8a39-9b18705dbccd",
        "storage_key": "property/6767906449165624/019db074-f379-74cb-8a39-9b18705dbccd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our pet-friendly community with a dedicated dog park for your furry friends.",
      "link": "",
      "alt_text": "Dog park with benches, waste station, and walking paths",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_82e05843-28f6-4ffc-8106-99151b2fc672",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db074-f5c1-760c-877a-cabaa00fd530.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with a built-in gas grill under a wooden pergola and brick columns.",
        "public_id": "019db074-f5c1-760c-877a-cabaa00fd530",
        "storage_key": "property/6767906449165624/019db074-f5c1-760c-877a-cabaa00fd530.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our community's outdoor grilling station, complete with a gas grill and shaded seating area.",
      "link": "",
      "alt_text": "Outdoor grilling station with a built-in gas grill under a wooden pergola and brick columns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_194b4606-f800-4718-a7aa-839929f83516",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db074-fc85-752d-bbe4-96037d9a7c9c.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two stainless steel grills under a pergola.",
        "public_id": "019db074-fc85-752d-bbe4-96037d9a7c9c",
        "storage_key": "property/6767906449165624/019db074-fc85-752d-bbe4-96037d9a7c9c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our community's convenient grilling stations, perfect for gathering with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor grilling station with two stainless steel grills under a pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c38898bb-e12a-4ef7-8a2f-04c8eac2c2b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db074-e621-73c3-9850-e926de779f7b.webp",
      "image_media": {
        "alt_text": "Playground at Shadow Ridge Apartments",
        "public_id": "019db074-e621-73c3-9850-e926de779f7b",
        "storage_key": "property/6767906449165624/019db074-e621-73c3-9850-e926de779f7b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Children's playground area with slides and climbing structures at Shadow Ridge Apartments, shaded by a blue canopy.",
      "link": "",
      "alt_text": "Playground at Shadow Ridge Apartments",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_15877998-9896-4ab8-9818-1bbc67f75e3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db074-d53d-71cc-8a58-3278c041cc39.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a water tower in the background.",
        "public_id": "019db074-d53d-71cc-8a58-3278c041cc39",
        "storage_key": "property/6767906449165624/019db074-d53d-71cc-8a58-3278c041cc39.webp",
        "width": 3072,
        "height": 2076
      },
      "title": "Community",
      "description": "Aerial view showcasing the exterior of apartment buildings, highlighting their architecture and surrounding landscaping, with a prominent water tower visible in the distance.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a water tower in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6050ada4-2ad9-4d08-a8d7-8b9b01afd5d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db074-c22e-717f-a743-a67ae70259ad.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019db074-c22e-717f-a743-a67ae70259ad",
        "storage_key": "property/6767906449165624/019db074-c22e-717f-a743-a67ae70259ad.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_47817a6b-cb59-423c-bc32-eb1200d2fdc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db074-c30b-77db-9e28-e46d1b57dab0.webp",
      "image_media": {
        "alt_text": "Shadow Ridge Apartments monument sign with brick facade and landscaping.",
        "public_id": "019db074-c30b-77db-9e28-e46d1b57dab0",
        "storage_key": "property/6767906449165624/019db074-c30b-77db-9e28-e46d1b57dab0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Shadow Ridge Apartments. Explore our community amenities and find your perfect home.",
      "link": "",
      "alt_text": "Shadow Ridge Apartments monument sign with brick facade and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_124448e6-16fd-48cc-9820-32a24516d47d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db074-be62-701b-8981-b842819ccd8c.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a water tower in the background.",
        "public_id": "019db074-be62-701b-8981-b842819ccd8c",
        "storage_key": "property/6767906449165624/019db074-be62-701b-8981-b842819ccd8c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Spacious apartment complex with multiple buildings, lush greenery, and a visible water tower on the horizon.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a water tower in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f66a9e50-3ee5-478e-a805-bb63f58125d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db074-bd13-765e-9aac-e9a60d9f62b5.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding community, showing parking lots and a street.",
        "public_id": "019db074-bd13-765e-9aac-e9a60d9f62b5",
        "storage_key": "property/6767906449165624/019db074-bd13-765e-9aac-e9a60d9f62b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "An aerial view showcasing the apartment complex's exterior, parking areas, and the surrounding neighborhood streetscape.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and surrounding community, showing parking lots and a street.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fbb31729-7d15-400d-84e6-5640cf25ff87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db074-b069-72ec-82e9-e44777aa0885.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washing machines and dryers.",
        "public_id": "019db074-b069-72ec-82e9-e44777aa0885",
        "storage_key": "property/6767906449165624/019db074-b069-72ec-82e9-e44777aa0885.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities available for residents, equipped with modern washers and dryers for easy chore completion.",
      "link": "",
      "alt_text": "Laundry room with multiple washing machines and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d3a149e-28c1-4231-b3a0-0c6692cf4f64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db076-ccaf-707c-ac4f-d7657d01692d.webp",
      "image_media": {
        "alt_text": "Spacious community lounge area with a large sectional sofa, fireplace, dining table, and a full kitchen.",
        "public_id": "019db076-ccaf-707c-ac4f-d7657d01692d",
        "storage_key": "property/6767906449165624/019db076-ccaf-707c-ac4f-d7657d01692d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a cozy fireplace, ample seating, a dining area, and a convenient full kitchen.",
      "link": "",
      "alt_text": "Spacious community lounge area with a large sectional sofa, fireplace, dining table, and a full kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bdb5db90-72ec-4857-8d95-6cb6ac9b8aca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db077-42dc-72e5-8cdc-27b2ee66b254.webp",
      "image_media": {
        "alt_text": "Living room with a leather sofa, coffee table, armchair, and balcony access.",
        "public_id": "019db077-42dc-72e5-8cdc-27b2ee66b254",
        "storage_key": "property/6767906449165624/019db077-42dc-72e5-8cdc-27b2ee66b254.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and inviting living area featuring a comfortable leather sofa, a stylish coffee table, and an armchair. Enjoy natural light and access to a private balcony.",
      "link": "",
      "alt_text": "Living room with a leather sofa, coffee table, armchair, and balcony access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_24cc9c0f-f5d0-4108-b7fb-3b7c7b26e27c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db077-420d-7728-8597-5584099981a2.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "019db077-420d-7728-8597-5584099981a2",
        "storage_key": "property/6767906449165624/019db077-420d-7728-8597-5584099981a2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with a wide range of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51623c69-cb51-42f5-9e90-68265a5966a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db077-4312-7429-af80-19cffa0cf599.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "019db077-4312-7429-af80-19cffa0cf599",
        "storage_key": "property/6767906449165624/019db077-4312-7429-af80-19cffa0cf599.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring treadmills, ellipticals, weight machines, and free weights.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f22a73de-dd07-4e15-abf2-8b946d5aa372",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db077-bb1e-771d-9744-d2f367a7279d.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, and TV with nature scene.",
        "public_id": "019db077-bb1e-771d-9744-d2f367a7279d",
        "storage_key": "property/6767906449165624/019db077-bb1e-771d-9744-d2f367a7279d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, accent chair, coffee table, and a large TV displaying a nature scene. Open to a modern kitchen with bar seating.",
      "link": "",
      "alt_text": "Living room with sofa, armchair, coffee table, and TV with nature scene.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_967ae961-5fa1-4d79-8130-c8aa7f61b347",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db077-b948-717c-afd3-dff20e7800b8.webp",
      "image_media": {
        "alt_text": "Kitchen with yellow cabinets, white appliances, and a sink.",
        "public_id": "019db077-b948-717c-afd3-dff20e7800b8",
        "storage_key": "property/6767906449165624/019db077-b948-717c-afd3-dff20e7800b8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring yellow cabinetry, white appliances including a stove and refrigerator, and a double sink. Perfect for home-cooked meals.",
      "link": "",
      "alt_text": "Kitchen with yellow cabinets, white appliances, and a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e821c1ad-d479-446b-ad30-1ba897120512",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db077-b942-70d0-a5f6-47dbe02937bb.webp",
      "image_media": {
        "alt_text": "View from a balcony overlooking palm trees and apartment buildings.",
        "public_id": "019db077-b942-70d0-a5f6-47dbe02937bb",
        "storage_key": "property/6767906449165624/019db077-b942-70d0-a5f6-47dbe02937bb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy your morning coffee on your private balcony, surrounded by lush greenery and scenic views.",
      "link": "",
      "alt_text": "View from a balcony overlooking palm trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9b05cc2e-f5d7-44ad-a931-5ccc6681a034",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db078-cc8d-76a0-b0a6-eb188e8e3f27.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with balconies and walkways",
        "public_id": "019db078-cc8d-76a0-b0a6-eb188e8e3f27",
        "storage_key": "property/6767906449165624/019db078-cc8d-76a0-b0a6-eb188e8e3f27.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings showcasing balconies, walkways, and landscaped grounds with gravel and bushes.",
      "link": "",
      "alt_text": "Apartment building exterior with balconies and walkways",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b65776ee-a6b8-4c5b-a4d4-7082061ac1f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db078-b18c-7054-92b2-bce65c204c55.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, white comforter, wooden headboard, and decorative pillows.",
        "public_id": "019db078-b18c-7054-92b2-bce65c204c55",
        "storage_key": "property/6767906449165624/019db078-b18c-7054-92b2-bce65c204c55.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, featuring a plush queen-size bed, a stylish wooden headboard, and ample natural light.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, white comforter, wooden headboard, and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_251c0f88-6cf2-47a0-b7d8-492b4c71dd79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db078-a9cc-7695-975e-9bf2e0b6d7ac.webp",
      "image_media": {
        "alt_text": "A child's bedroom featuring a queen-size bed with animal-themed bedding and wall art.",
        "public_id": "019db078-a9cc-7695-975e-9bf2e0b6d7ac",
        "storage_key": "property/6767906449165624/019db078-a9cc-7695-975e-9bf2e0b6d7ac.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Decorated with playful animal art and cozy bedding, this bedroom is perfect for a child's retreat.",
      "link": "",
      "alt_text": "A child's bedroom featuring a queen-size bed with animal-themed bedding and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_83620401-7954-4c04-8a12-2d3341fe5648",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db078-918d-75ff-abc9-f62e606d1c9c.webp",
      "image_media": {
        "alt_text": "Living room with a desk, armchair, and sofa.",
        "public_id": "019db078-918d-75ff-abc9-f62e606d1c9c",
        "storage_key": "property/6767906449165624/019db078-918d-75ff-abc9-f62e606d1c9c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Bright and airy living room featuring a comfortable sofa, accent armchair, and a functional desk area. Perfect for relaxing or working from home.",
      "link": "",
      "alt_text": "Living room with a desk, armchair, and sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f57a9c08-c9ce-4861-b06d-8fb0203a326a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db078-909b-701c-b944-a97286432926.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, yellow cabinets, and decorative wall baskets.",
        "public_id": "019db078-909b-701c-b944-a97286432926",
        "storage_key": "property/6767906449165624/019db078-909b-701c-b944-a97286432926.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring white appliances, ample cabinet space, and decorative accents.",
      "link": "",
      "alt_text": "Kitchen with white appliances, yellow cabinets, and decorative wall baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a76eef4f-eb0c-4ca9-87a6-5652289cbd47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db079-a6fb-7329-9706-f598761298a2.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and trees at a multifamily property.",
        "public_id": "019db079-a6fb-7329-9706-f598761298a2",
        "storage_key": "property/6767906449165624/019db079-a6fb-7329-9706-f598761298a2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs for ultimate relaxation.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and trees at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5ba9c6b4-7d31-450b-bf3e-54bc4f3e0f00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db079-a279-756e-8853-4f43afbb76b2.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills, a circular table, and chairs under a wooden pergola.",
        "public_id": "019db079-a279-756e-8853-4f43afbb76b2",
        "storage_key": "property/6767906449165624/019db079-a279-756e-8853-4f43afbb76b2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our community grilling station, complete with modern grills and comfortable seating, perfect for gatherings.",
      "link": "",
      "alt_text": "Outdoor grilling area with two built-in grills, a circular table, and chairs under a wooden pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5fa4419e-7664-4696-8b38-0988a7456b45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db079-8801-7695-aa86-cc893bbf047e.webp",
      "image_media": {
        "alt_text": "Dog park agility equipment and benches with apartment buildings in the background.",
        "public_id": "019db079-8801-7695-aa86-cc893bbf047e",
        "storage_key": "property/6767906449165624/019db079-8801-7695-aa86-cc893bbf047e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility equipment and plenty of space for your furry friends to play. Located near the apartment buildings.",
      "link": "",
      "alt_text": "Dog park agility equipment and benches with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_94367c1f-adf9-4f21-a27c-11c931af3973",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db079-72aa-72fa-aa23-757ccd37e139.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washing machines and dryers.",
        "public_id": "019db079-72aa-72fa-aa23-757ccd37e139",
        "storage_key": "property/6767906449165624/019db079-72aa-72fa-aa23-757ccd37e139.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "On-site laundry facilities with washers and dryers available for resident use.",
      "link": "",
      "alt_text": "Laundry room with multiple washing machines and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57d1067c-8767-41e4-a010-dbae1d9d4d96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019db079-72a9-7660-a3b2-5a3a0fcf3359.webp",
      "image_media": {
        "alt_text": "Community laundry room with washers and dryers",
        "public_id": "019db079-72a9-7660-a3b2-5a3a0fcf3359",
        "storage_key": "property/6767906449165624/019db079-72a9-7660-a3b2-5a3a0fcf3359.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities with multiple washing machines and dryers available for resident use.",
      "link": "",
      "alt_text": "Community laundry room with washers and dryers",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a6e52416-48fc-4248-b277-260b30c36f96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Teppanyaki Grill & Buffet",
      "poi_type": "Restaurants",
      "poi_address": "8300 Gtwy Blvd E, El Paso, TX 79907, USA",
      "poi_short_description": "All-you-can-eat establishment featuring Chinese and Japanese eats, including teppanyaki.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of fresh food, including sushi, steak, and Mexican dishes. They also highlight the reasonable prices and friendly staff.\n\nOther reviews mention the restaurant can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-6122-72ca-9a76-4ded3743ebee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6122-72ca-9a76-4ded3743ebee",
        "storage_key": "property/6767906449165624/019d2709-6122-72ca-9a76-4ded3743ebee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ocs.ink/Teppanyaki_MenuPrice",
      "poi_directions_map_url": "https://maps.google.com/?cid=4709443183176625985&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "teppanyaki-grill--buffet",
      "poi_latitude": "31.7408162",
      "poi_longitude": "-106.328057",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-595-6980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c48-71e8-9607-59a5fcdd9d72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c48-71e8-9607-59a5fcdd9d72",
        "storage_key": "property/6767906449165624/019d2709-9c48-71e8-9607-59a5fcdd9d72.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRseKF9D54YRQa8gl59NW0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_05d3a49f-538f-4f29-939b-af8d49b37551",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "L & J Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3622 E Missouri Ave, El Paso, TX 79903, USA",
      "poi_short_description": "A local landmark dating back to 1927, this family-run eatery serves regional Mexican dishes & beers.",
      "poi_long_description": "People say this Mexican restaurant serves delicious green chile chicken enchiladas, steak tacos, and caldo de res. They highlight the affordable prices, generous portions, and the restaurant's history. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-6087-73ba-8fda-de6383580a1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6087-73ba-8fda-de6383580a1a",
        "storage_key": "property/6767906449165624/019d2709-6087-73ba-8fda-de6383580a1a.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://ljcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=253529114313290020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "l--j-cafe",
      "poi_latitude": "31.7795154",
      "poi_longitude": "-106.4497953",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-566-8418",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c48-71e8-9607-59a5fcdd9d72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c48-71e8-9607-59a5fcdd9d72",
        "storage_key": "property/6767906449165624/019d2709-9c48-71e8-9607-59a5fcdd9d72.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy58M-oRZ54YRJPHc3mK3hAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f1f29ef9-2e60-43f1-b150-36192e7622c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "10729 Gateway Blvd W, El Paso, TX 79935, USA",
      "poi_short_description": "Casual, family-friendly steakhouse chain known for peanuts on the floor and warm rolls, plus beer and cocktails.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, chili, chicken, and rolls. They also highlight the fresh rolls, friendly staff, and attentive service.\n\nOther reviews mention the wait time can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-60b7-759b-839e-319bc03bc684.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-60b7-759b-839e-319bc03bc684",
        "storage_key": "property/6767906449165624/019d2709-60b7-759b-839e-319bc03bc684.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/el-paso-gateway-west-blvd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7533061792699482454&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "31.7512399",
      "poi_longitude": "-106.3414628",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-591-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c48-71e8-9607-59a5fcdd9d72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c48-71e8-9607-59a5fcdd9d72",
        "storage_key": "property/6767906449165624/019d2709-9c48-71e8-9607-59a5fcdd9d72.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKd43xq1E54YRVoHr4MnPimg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_82eec2b4-91ef-465e-8f2a-c2344567fac7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "1300 Airway Blvd A, El Paso, TX 79925, USA",
      "poi_short_description": "Fast-food chain known for its chicken sandwiches and waffle fries, plus breakfast and salads.",
      "poi_long_description": "Diners say this chicken restaurant serves up delicious sandwiches and sauces, and many appreciate the friendly and helpful staff. They also highlight the fast service and efficient drive-thru.\n\nSome reviews mention the orders can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-652c-727f-8de3-b73bb91ac68f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-652c-727f-8de3-b73bb91ac68f",
        "storage_key": "property/6767906449165624/019d2709-652c-727f-8de3-b73bb91ac68f.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/airway-edgemere?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10689403544732552595&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "31.7856951",
      "poi_longitude": "-106.3949539",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-771-7870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c48-71e8-9607-59a5fcdd9d72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c48-71e8-9607-59a5fcdd9d72",
        "storage_key": "property/6767906449165624/019d2709-9c48-71e8-9607-59a5fcdd9d72.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP2zLq5db54YRk82VmONjWJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_c54bf3db-b637-4cf9-83d4-09c319de6ffa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Cielo Vista Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "8401 Gateway Blvd W, El Paso, TX 79925, USA",
      "poi_short_description": "Classy retail complex with 2 floors of department stores & specialty shops, plus a movie theater.",
      "poi_long_description": "Classy retail complex with 2 floors of department stores & specialty shops, plus a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-65c6-7752-956a-1e5536166b55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-65c6-7752-956a-1e5536166b55",
        "storage_key": "property/6767906449165624/019d2709-65c6-7752-956a-1e5536166b55.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/cielo-vista",
      "poi_directions_map_url": "https://maps.google.com/?cid=11576646027705312160&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cielo-vista-mall",
      "poi_latitude": "31.7750435",
      "poi_longitude": "-106.37921",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-779-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c25-7056-ab26-275e6395341e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c25-7056-ab26-275e6395341e",
        "storage_key": "property/6767906449165624/019d2709-9c25-7056-ab26-275e6395341e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo5kkYlRa54YRoOPP-zmCqKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_73d3fbf7-7082-420a-baad-dce04e8e0f01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "El Paso Community College - Valle Verde Campus",
      "poi_type": "Education",
      "poi_address": "919 Hunter Dr, El Paso, TX 79915, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-6ddc-70b9-adf9-383b345de670.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6ddc-70b9-adf9-383b345de670",
        "storage_key": "property/6767906449165624/019d2709-6ddc-70b9-adf9-383b345de670.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://epcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12932995833553831033&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-community-college---valle-verde-campus",
      "poi_latitude": "31.7521673",
      "poi_longitude": "-106.3697966",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-831-3722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c23-774a-835f-6170e6e6225c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c23-774a-835f-6170e6e6225c",
        "storage_key": "property/6767906449165624/019d2709-9c23-774a-835f-6170e6e6225c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG6fyDhhb54YReUSVTDA7e7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a6318ada-fcf8-4346-9969-1b2b2735d71c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "El Paso Zoo and Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "Train Station, 4001 E Paisano Dr, El Paso, TX 79905, USA",
      "poi_short_description": "Longstanding facility showcasing 250+ species within habitats, plus playground and cafe.",
      "poi_long_description": "People say this zoo offers a variety of animals, including penguins and giraffes, and has a fun splash pad and playground for children. They also highlight the affordable price, convenient size for families with young children, and friendly staff.\n\nOther reviews mention some exhibits can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-735c-74df-9219-f90224abd22f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-735c-74df-9219-f90224abd22f",
        "storage_key": "property/6767906449165624/019d2709-735c-74df-9219-f90224abd22f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elpasozoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9154948632860338008&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-zoo-and-botanical-gardens",
      "poi_latitude": "31.7690489",
      "poi_longitude": "-106.4448897",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-212-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c2e-762a-99be-fc34b8ddf8bb",
        "storage_key": "property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7ASQX5Z54YRWKeWzkbpDH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_0832de17-3bf1-444f-9223-523d995dbd3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "El Paso County Coliseum",
      "poi_type": "Entertainment",
      "poi_address": "4100 E Paisano Dr, El Paso, TX 79905, USA",
      "poi_short_description": "Venue known for its many concerts and events, including monster trucks and a Van Gogh exhibit.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-7435-77c8-a61f-4cf2adc32f3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7435-77c8-a61f-4cf2adc32f3e",
        "storage_key": "property/6767906449165624/019d2709-7435-77c8-a61f-4cf2adc32f3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://epcountycoliseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14120659578983158164&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-county-coliseum",
      "poi_latitude": "31.766561",
      "poi_longitude": "-106.4432224",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-534-4229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c2e-762a-99be-fc34b8ddf8bb",
        "storage_key": "property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52jcy31Z54YRlBGClxKp9sM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_25045f34-f73d-4faf-9cea-5ab2e377091e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Fort Bliss Museum",
      "poi_type": "Entertainment",
      "poi_address": "1735 Marshall Rd, Fort Bliss, TX 79906, USA",
      "poi_short_description": "Large, free museum with tanks, trucks and military displays, uniforms and artifacts documenting the history of Fort Bliss and the First Armored Division.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-75db-70ee-8991-c93ce01acb74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-75db-70ee-8991-c93ce01acb74",
        "storage_key": "property/6767906449165624/019d2709-75db-70ee-8991-c93ce01acb74.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://home.army.mil/bliss/index.php/my-fort/all-services/fort-bliss-and-old-ironsides-museu",
      "poi_directions_map_url": "https://maps.google.com/?cid=7293167302618848693&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss-museum",
      "poi_latitude": "31.8218243",
      "poi_longitude": "-106.4285014",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-568-5412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-a019-717c-898d-3b964152302f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a019-717c-898d-3b964152302f",
        "storage_key": "property/6767906449165624/019d2709-a019-717c-898d-3b964152302f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QxGxefF4IYRtR0XWAWJNmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_851449d7-6144-4533-a9ba-48bccee3ca19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Lost Kingdom Water Park",
      "poi_type": "Entertainment",
      "poi_address": "6001 Hughey Dr, El Paso, TX 79925, USA",
      "poi_short_description": "Water park with cabanas, lounging areas, plus a lazy river and a climbing wall.",
      "poi_long_description": "People say this water park offers a variety of pools suitable for all ages, including a lazy river, kiddie area, and a large pool with varying depths. They also highlight the attentive lifeguards, friendly staff, and clean facilities.\n\nOther reviews mention the food can be pricey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-784c-751f-ad2e-7560ee458e14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-784c-751f-ad2e-7560ee458e14",
        "storage_key": "property/6767906449165624/019d2709-784c-751f-ad2e-7560ee458e14.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://epwaterparks.com/lost-kingdom",
      "poi_directions_map_url": "https://maps.google.com/?cid=6079401926571752602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lost-kingdom-water-park",
      "poi_latitude": "31.7906268",
      "poi_longitude": "-106.4149103",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-541-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c2e-762a-99be-fc34b8ddf8bb",
        "storage_key": "property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJffNdBLFb54YRmnwimNdfXlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_983dbf95-e634-46bd-9e26-25488464048f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Joshua W. Soto Physical Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "20751 Constitution Ave, Fort Bliss, TX 79918, USA",
      "poi_short_description": "Gym featuring a basketball court and clean showers and equipment, as well as a track.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including cardio machines, weightlifting equipment, and basketball courts, as well as an indoor track and sauna. They highlight the gym's spacious layout, clean facilities, and the availability of a smoothie store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-7a97-703b-b142-19dd43d25114.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7a97-703b-b142-19dd43d25114",
        "storage_key": "property/6767906449165624/019d2709-7a97-703b-b142-19dd43d25114.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://bliss.armymwr.com/programs/joshua-w-soto-physical-fitness-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9843518981860297653&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "joshua-w-soto-physical-fitness-center",
      "poi_latitude": "31.849859",
      "poi_longitude": "-106.3546891",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 915-744-5788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c2e-762a-99be-fc34b8ddf8bb",
        "storage_key": "property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-dhbjxhQ54YRtQuZXVw0m4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f9c3d851-4e81-4c48-b565-8bc0cf2c7a33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6375 Montana Ave, El Paso, TX 79925, USA",
      "poi_short_description": "Treadmill-equipped facility featuring a variety of exercise machines and free weights, plus showers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-7a71-72e7-8534-15a5f905dfd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7a71-72e7-8534-15a5f905dfd5",
        "storage_key": "property/6767906449165624/019d2709-7a71-72e7-8534-15a5f905dfd5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/el-paso-montana-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12897887577583852119&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.7898711",
      "poi_longitude": "-106.4046699",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-778-7867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c2e-762a-99be-fc34b8ddf8bb",
        "storage_key": "property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsV_A0TFa54YRVxrPdmqA_rI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_521a7c65-9fe3-4f6d-a7bb-f78581f59a5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Mitchell W. Stout Physical Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2930 Cassidy Rd, Fort Bliss, TX 79916, USA",
      "poi_short_description": "Gym featuring weightlifting equipment and treadmills, plus an informal cafe.",
      "poi_long_description": "People say this gym offers a variety of cardio and strength machines, including squat racks and specialty bars, as well as a basketball court and indoor track. They also highlight the spacious layout, clean facilities, and friendly staff.\n\nOther reviews mention the equipment can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-7e16-7419-a9ca-a5af84a0beee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7e16-7419-a9ca-a5af84a0beee",
        "storage_key": "property/6767906449165624/019d2709-7e16-7419-a9ca-a5af84a0beee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bliss.armymwr.com/programs/stout-physical-fitness-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=1842470217454083497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mitchell-w-stout-physical-fitness-center",
      "poi_latitude": "31.8136567",
      "poi_longitude": "-106.4057176",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-568-3264",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c2e-762a-99be-fc34b8ddf8bb",
        "storage_key": "property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL0ZIfHBa54YRqV2WpObEkRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1460eaf4-a6e1-49c6-8ecf-1558475d9330",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Powerhouse Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "1840 Lee Trevino Dr Ste 100, El Paso, TX 79936, USA",
      "poi_short_description": "Spacious fitness center featuring a range of equipment, tanning services, and a juice bar.",
      "poi_long_description": "People say this fitness center offers a wide variety of machines, equipment, and classes, including cycling and yoga. They highlight the clean and well-maintained facilities, and the positive, energetic, and motivating vibe. They also like the friendly, helpful, and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-7f77-772e-b741-1e86a3bbe550.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7f77-772e-b741-1e86a3bbe550",
        "storage_key": "property/6767906449165624/019d2709-7f77-772e-b741-1e86a3bbe550.webp",
        "width": 1280,
        "height": 683
      },
      "poi_business_url": "https://powerhousegym.com/locations/elpaso-tx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6635965948837574386&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "powerhouse-gym",
      "poi_latitude": "31.7659573",
      "poi_longitude": "-106.3174303",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-525-8698",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c2e-762a-99be-fc34b8ddf8bb",
        "storage_key": "property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb1vRdAFF54YR8jYNIt-vF1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_63ca1579-8c49-4397-9524-ac6f4e67371f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Crunch Fitness - El Paso Zaragoza",
      "poi_type": "Health and Wellness",
      "poi_address": "2060 N Zaragoza Rd, El Paso, TX 79938, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including cardio machines, strength training equipment, and a sauna, and provides amenities such as childcare and group classes.\n\nOther reviews mention the gym can be crowded and parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-7f94-768b-9518-8bcbb8a550ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7f94-768b-9518-8bcbb8a550ab",
        "storage_key": "property/6767906449165624/019d2709-7f94-768b-9518-8bcbb8a550ab.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/el-paso-zaragoza",
      "poi_directions_map_url": "https://maps.google.com/?cid=4890488308138438886&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---el-paso-zaragoza",
      "poi_latitude": "31.7665388",
      "poi_longitude": "-106.2612729",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 915-336-0250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c2e-762a-99be-fc34b8ddf8bb",
        "storage_key": "property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMfvh2WRF54YR5vDKkDSB3kM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2f5403a0-80ae-4b02-92a3-58095af645ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1430 Lee Trevino Dr, El Paso, TX 79936, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-7f02-76e7-acf2-0845d119ed65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7f02-76e7-acf2-0845d119ed65",
        "storage_key": "property/6767906449165624/019d2709-7f02-76e7-acf2-0845d119ed65.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/tx/el-paso-mega-lee-trevino/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8078410797069877127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "31.7463727",
      "poi_longitude": "-106.3173561",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-593-3133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c2e-762a-99be-fc34b8ddf8bb",
        "storage_key": "property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe6nW6-dF54YRh78HldFHHHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_889cb0f1-fb1f-4b87-b21f-66240dbdc644",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "8889 Gateway Blvd W #560, El Paso, TX 79925, USA",
      "poi_short_description": "Beauty-focused chain retailer carrying cosmetics, hair-care products, skin care, fragrance and more, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-834a-70e9-8c4d-d0870e10dfe5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-834a-70e9-8c4d-d0870e10dfe5",
        "storage_key": "property/6767906449165624/019d2709-834a-70e9-8c4d-d0870e10dfe5.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.ulta.com/stores/el-paso-tx-546",
      "poi_directions_map_url": "https://maps.google.com/?cid=9657051227726067395&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "31.7708142",
      "poi_longitude": "-106.3712054",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-595-6458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-9c2e-762a-99be-fc34b8ddf8bb",
        "storage_key": "property/6767906449165624/019d2709-9c2e-762a-99be-fc34b8ddf8bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD7XR7Bdb54YRw7ZcJu28BIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_cabe019f-64f0-47b7-b9a8-5261bed9e120",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "William Beaumont Army Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "18511 Highlander Medics St, Fort Bliss, TX 79906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-8487-719b-90f8-1d399308654d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8487-719b-90f8-1d399308654d",
        "storage_key": "property/6767906449165624/019d2709-8487-719b-90f8-1d399308654d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://william-beaumont.tricare.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17654552171002598951&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "william-beaumont-army-medical-center",
      "poi_latitude": "31.8324614",
      "poi_longitude": "-106.3243973",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 915-742-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-a0c0-758a-89dd-991f219ce0a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0c0-758a-89dd-991f219ce0a1",
        "storage_key": "property/6767906449165624/019d2709-a0c0-758a-89dd-991f219ce0a1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw1V1l0hP54YRJxY2ZamRAfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2b4dc65c-48f2-4b5d-a6c4-fdceb6164a78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1701 N Copia St, El Paso, TX 79930, USA",
      "poi_short_description": "Park featuring hills and shaded areas, an ice-cream truck, a playground and tennis courts for activities like walking and picnics.",
      "poi_long_description": "People say this city park offers plenty of grass for picnics and games, a playground, and shade from numerous trees. They highlight the peaceful and relaxing vibe, and the well-maintained grounds. They also like the nearby ice cream truck and library branch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-8842-70cc-aa53-826e707f71f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8842-70cc-aa53-826e707f71f3",
        "storage_key": "property/6767906449165624/019d2709-8842-70cc-aa53-826e707f71f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=615165719072263059&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "31.7894065",
      "poi_longitude": "-106.4571558",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-a0ad-753d-96e7-3fbd5b2f3613.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0ad-753d-96e7-3fbd5b2f3613",
        "storage_key": "property/6767906449165624/019d2709-a0ad-753d-96e7-3fbd5b2f3613.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9_YWrJNZ54YRk8tMU_aBiQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_71333241-a9ea-4d11-aecd-8925ecdb323d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Blackie Chesher Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1100 N Zaragoza Rd, El Paso, TX 79907, USA",
      "poi_short_description": "Athletic complex with baseball and soccer fields, paved walkways, and multiple playgrounds.",
      "poi_long_description": "Sizable park featuring a playground, walking path & fields for soccer & baseball/softball.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-89ef-75bc-bcb9-e0300c0bc32d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-89ef-75bc-bcb9-e0300c0bc32d",
        "storage_key": "property/6767906449165624/019d2709-89ef-75bc-bcb9-e0300c0bc32d.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.elpasotexas.gov/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6374719998777487238&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blackie-chesher-park",
      "poi_latitude": "31.714197",
      "poi_longitude": "-106.3056358",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-a0ad-753d-96e7-3fbd5b2f3613.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0ad-753d-96e7-3fbd5b2f3613",
        "storage_key": "property/6767906449165624/019d2709-a0ad-753d-96e7-3fbd5b2f3613.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRRclQ9D54YRhu-1bRCOd1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_28f9f899-b15e-48e0-941e-03e9c394a96f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Marty Robbins Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11620 Vista Del Sol Dr, El Paso, TX 79936, USA",
      "poi_short_description": "Green area, also featuring an indoor pool, plus a clean splash pad and water park.",
      "poi_long_description": "Community park with a pool, sports fields, basketball courts, playground & restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-8f11-7511-bf9d-830804e3ff69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8f11-7511-bf9d-830804e3ff69",
        "storage_key": "property/6767906449165624/019d2709-8f11-7511-bf9d-830804e3ff69.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=12814619974849682047&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "marty-robbins-park",
      "poi_latitude": "31.7497559",
      "poi_longitude": "-106.2969227",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-212-0426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-a0ad-753d-96e7-3fbd5b2f3613.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a0ad-753d-96e7-3fbd5b2f3613",
        "storage_key": "property/6767906449165624/019d2709-a0ad-753d-96e7-3fbd5b2f3613.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7RinpH9E54YRf1qK7Pis1rE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2e7ca4d5-2ae9-4df1-9014-d6eb27a14a30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "El Paso International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6701 Convair Rd, El Paso, TX 79925, USA",
      "poi_short_description": "Established in 1928, this small airport offers free WiFi & a cell phone waiting lot.",
      "poi_long_description": "People say this international airport is easy to navigate and has quick security. They highlight the efficient layout, convenient access to rental cars, and friendly staff. They also like the clean facilities and festive holiday decorations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-8e14-73a0-99f5-18683261cdc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8e14-73a0-99f5-18683261cdc8",
        "storage_key": "property/6767906449165624/019d2709-8e14-73a0-99f5-18683261cdc8.webp",
        "width": 1280,
        "height": 415
      },
      "poi_business_url": "http://www.elpasointernationalairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2247101600509703497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-international-airport",
      "poi_latitude": "31.8058228",
      "poi_longitude": "-106.3705379",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-212-0330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-a481-761f-ac96-e8f7c8258951.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a481-761f-ac96-e8f7c8258951",
        "storage_key": "property/6767906449165624/019d2709-a481-761f-ac96-e8f7c8258951.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQ9mvJNa54YRSbWXAABPLx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_9288f2b5-3d95-4d98-92c9-1ca14e2f4aee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Fort Bliss A/DACG",
      "poi_type": "Transportation & Transit",
      "poi_address": "Fort Bliss, TX 79918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-8dbe-7090-b1c3-2c610893104e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8dbe-7090-b1c3-2c610893104e",
        "storage_key": "property/6767906449165624/019d2709-8dbe-7090-b1c3-2c610893104e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://home.army.mil/hood/index.php/units-tenants/installation-transportation-office/arrivaldeparture-airfield-control-group-dacg",
      "poi_directions_map_url": "https://maps.google.com/?cid=10912390521258870755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss-adacg",
      "poi_latitude": "31.8294155",
      "poi_longitude": "-106.4096364",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-568-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-a481-761f-ac96-e8f7c8258951.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a481-761f-ac96-e8f7c8258951",
        "storage_key": "property/6767906449165624/019d2709-a481-761f-ac96-e8f7c8258951.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJjx8btptQ54YR44f53VyZcJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_e3e3b2dc-1d6b-4696-bb16-69eec91671b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Concourse East",
      "poi_type": "Transportation & Transit",
      "poi_address": "6725 Convair Rd, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-8e57-75da-a993-24045b684bb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8e57-75da-a993-24045b684bb8",
        "storage_key": "property/6767906449165624/019d2709-8e57-75da-a993-24045b684bb8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10886375157866865864&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "concourse-east",
      "poi_latitude": "31.79992469999999",
      "poi_longitude": "-106.3949994",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-a481-761f-ac96-e8f7c8258951.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a481-761f-ac96-e8f7c8258951",
        "storage_key": "property/6767906449165624/019d2709-a481-761f-ac96-e8f7c8258951.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJcbkIwF9a54YRyKRKEIcsFJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_2e86451b-b715-42ba-bbfb-1f1eeece0f35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Concourse West",
      "poi_type": "Transportation & Transit",
      "poi_address": "El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-9260-74ca-ace7-6a9b7953c2fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9260-74ca-ace7-6a9b7953c2fc",
        "storage_key": "property/6767906449165624/019d2709-9260-74ca-ace7-6a9b7953c2fc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17291459108056858109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "concourse-west",
      "poi_latitude": "31.7999686",
      "poi_longitude": "-106.3963419",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d2709-a481-761f-ac96-e8f7c8258951.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-a481-761f-ac96-e8f7c8258951",
        "storage_key": "property/6767906449165624/019d2709-a481-761f-ac96-e8f7c8258951.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-QA_y19a54YR_f3r13Ga9-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_7fb0e283-e5ee-4c2d-9391-0062008ca7b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Scotsdale Elementary School",
      "poi_type": "Education",
      "poi_address": "2901 McRae Blvd, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://scotsdale.yisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2590355423952842844&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "scotsdale-elementary-school",
      "poi_latitude": "31.781832",
      "poi_longitude": "-106.357279",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-434-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3bfa-73aa-be4a-255d6a4f2807",
        "storage_key": "property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiWjJayhb54YRXDC3pojK8iM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6fbcc552-1011-4067-9a3a-ed5676ea6c33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Eastwood Heights Elementary School",
      "poi_type": "Education",
      "poi_address": "10530 Janway Dr, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yisd.net/eastwoodheights",
      "poi_directions_map_url": "https://maps.google.com/?cid=4229778720190647605&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eastwood-heights-elementary-school",
      "poi_latitude": "31.7667433",
      "poi_longitude": "-106.3425792",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-434-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3bfa-73aa-be4a-255d6a4f2807",
        "storage_key": "property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6SvLxstE54YRNU1471Uxszo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ec9c07c1-709e-4de5-96ad-c26a4d94813b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "East Point Elementary School",
      "poi_type": "Education",
      "poi_address": "2400 Zanzibar Rd, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://eastpoint.yisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15228087567138120012&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "east-point-elementary-school",
      "poi_latitude": "31.7767138",
      "poi_longitude": "-106.3433352",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-434-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3bfa-73aa-be4a-255d6a4f2807",
        "storage_key": "property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7ce14dJE54YRTGHP3_UIVdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_bc1a74d6-d2e4-46e9-8f87-74e122b243be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Edgemere Elementary School",
      "poi_type": "Education",
      "poi_address": "10300 Edgemere Blvd, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-0f65-7289-baf4-4fa17c02f941.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0f65-7289-baf4-4fa17c02f941",
        "storage_key": "property/6767906449165624/019d7913-0f65-7289-baf4-4fa17c02f941.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://edgemere.yisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6390919449137768535&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "edgemere-elementary-school",
      "poi_latitude": "31.7882631",
      "poi_longitude": "-106.338653",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-434-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3bfa-73aa-be4a-255d6a4f2807",
        "storage_key": "property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjzVBgylF54YRV-j94WAbsVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9e0bcea8-4985-4e6c-8f26-8bd0a1c6c178",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Hughey Elementary School",
      "poi_type": "Education",
      "poi_address": "6201 Hughey Dr, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-2f95-77e3-820b-b96d8f70c78d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2f95-77e3-820b-b96d8f70c78d",
        "storage_key": "property/6767906449165624/019d7913-2f95-77e3-820b-b96d8f70c78d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6254902822520838856&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hughey-elementary-school",
      "poi_latitude": "31.7898596",
      "poi_longitude": "-106.4102844",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-236-0250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3bfa-73aa-be4a-255d6a4f2807",
        "storage_key": "property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw0ANw0Va54YRyFrxKPrgzVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_891d7e12-d177-4946-bcfa-c4f400f743f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "MacArthur Elementary-Intermediate School",
      "poi_type": "Education",
      "poi_address": "8101 Whitus Dr, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-109b-72d6-a45b-be5082b79e80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-109b-72d6-a45b-be5082b79e80",
        "storage_key": "property/6767906449165624/019d7913-109b-72d6-a45b-be5082b79e80.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.episd.org/macarthur",
      "poi_directions_map_url": "https://maps.google.com/?cid=17379111297777122840&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "macarthur-elementary-intermediate-school",
      "poi_latitude": "31.781582",
      "poi_longitude": "-106.3779079",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-236-0625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3bfa-73aa-be4a-255d6a4f2807",
        "storage_key": "property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4dgNd-Ja54YRGL77l6UBL_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_687e994d-3236-4a0d-902c-c797d73709b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Socorro Middle School",
      "poi_type": "Education",
      "poi_address": "321 Bovee Rd, Socorro, TX 79927, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-12bb-76f4-b010-8cad516a899b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-12bb-76f4-b010-8cad516a899b",
        "storage_key": "property/6767906449165624/019d7913-12bb-76f4-b010-8cad516a899b.webp",
        "width": 1280,
        "height": 444
      },
      "poi_business_url": "https://www.sisd.net/o/socorroms",
      "poi_directions_map_url": "https://maps.google.com/?cid=16724908285844847820&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "socorro-middle-school",
      "poi_latitude": "31.6376985",
      "poi_longitude": "-106.2855478",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 11 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 915-937-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3bfa-73aa-be4a-255d6a4f2807",
        "storage_key": "property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa5-8cbhp54YRzPzEPnnPGug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_293599b5-c84f-40cb-a180-ba33f402cc22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Eastwood High School",
      "poi_type": "Education",
      "poi_address": "2430 McRae Blvd, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-5ba4-720c-931b-a3aba6697772.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5ba4-720c-931b-a3aba6697772",
        "storage_key": "property/6767906449165624/019d7913-5ba4-720c-931b-a3aba6697772.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yisd.net/eastwoodhigh",
      "poi_directions_map_url": "https://maps.google.com/?cid=9939334275631886339&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eastwood-high-school",
      "poi_latitude": "31.7722351",
      "poi_longitude": "-106.3555024",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-434-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3bfa-73aa-be4a-255d6a4f2807",
        "storage_key": "property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYaQqTzBb54YRAzDn4tyb74k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_3ccf9e63-87cc-430c-93e5-01e15721e2a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "William H. Burges High School",
      "poi_type": "Education",
      "poi_address": "7800 Edgemere Blvd, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-2af9-705e-a48a-07e53ab5e0b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2af9-705e-a48a-07e53ab5e0b3",
        "storage_key": "property/6767906449165624/019d7913-2af9-705e-a48a-07e53ab5e0b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.episd.org/burges",
      "poi_directions_map_url": "https://maps.google.com/?cid=1261243011298308159&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "william-h-burges-high-school",
      "poi_latitude": "31.7848729",
      "poi_longitude": "-106.3846235",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-236-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3bfa-73aa-be4a-255d6a4f2807",
        "storage_key": "property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI8g-ffxa54YRPzDhH9bVgBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_61263cbf-0b0a-48cc-ac09-9cc20fb075c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "El Paso Community College - Administrative Services Center - EPCC ASC",
      "poi_type": "Education",
      "poi_address": "9050 Viscount Blvd, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-40ad-74a7-a7f5-53795ad904c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-40ad-74a7-a7f5-53795ad904c3",
        "storage_key": "property/6767906449165624/019d7913-40ad-74a7-a7f5-53795ad904c3.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.epcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7534995070927861015&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-paso-community-college-administrative-services-center-epcc-asc",
      "poi_latitude": "31.772572",
      "poi_longitude": "-106.371546",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-831-3722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3bfa-73aa-be4a-255d6a4f2807",
        "storage_key": "property/6767906449165624/019cfb47-3bfa-73aa-be4a-255d6a4f2807.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFYdOGxhb54YRF3X5ShiukWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5e578ad4-1102-4d6b-8e19-c919abe0ab83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "HomeGoods",
      "poi_type": "Restaurants",
      "poi_address": "8889 Gateway Blvd W, El Paso, TX 79925, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-3892-770d-b029-b3e7a9950877.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3892-770d-b029-b3e7a9950877",
        "storage_key": "property/6767906449165624/019d7913-3892-770d-b029-b3e7a9950877.webp",
        "width": 962,
        "height": 1280
      },
      "poi_business_url": "http://www.homegoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6843837735558503645&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "31.76960249999999",
      "poi_longitude": "-106.3688179",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-629-9798",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3b63-711e-8552-cfdc20ba5bff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3b63-711e-8552-cfdc20ba5bff",
        "storage_key": "property/6767906449165624/019cfb47-3b63-711e-8552-cfdc20ba5bff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1UXWbT1b54YR3dxgCCky-l4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_507aeaa7-0922-4498-84db-78d324e4c5ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Restaurants",
      "poi_address": "8889 Gateway Blvd W #120, El Paso, TX 79925, USA",
      "poi_short_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_long_description": "People say this bookstore offers a wide selection of books, magazines, comics, and manga, as well as toys, games, and craft supplies. They highlight the comfortable and relaxing atmosphere, and the presence of a Starbucks cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-4048-764c-ac3d-45296be1ed68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4048-764c-ac3d-45296be1ed68",
        "storage_key": "property/6767906449165624/019d7913-4048-764c-ac3d-45296be1ed68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2370",
      "poi_directions_map_url": "https://maps.google.com/?cid=5947523592233043213&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "barnes-noble",
      "poi_latitude": "31.7717509",
      "poi_longitude": "-106.3732609",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-594-3024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3b63-711e-8552-cfdc20ba5bff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3b63-711e-8552-cfdc20ba5bff",
        "storage_key": "property/6767906449165624/019cfb47-3b63-711e-8552-cfdc20ba5bff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgSDqWjlb54YRDUVOIDLZiVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_048d0388-fa91-4207-9fed-da3cf624496f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Eastgate Shopping Center",
      "poi_type": "Restaurants",
      "poi_address": "9801 Gateway Blvd W, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-4d28-774f-b07e-7eede5f99fe6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4d28-774f-b07e-7eede5f99fe6",
        "storage_key": "property/6767906449165624/019d7913-4d28-774f-b07e-7eede5f99fe6.webp",
        "width": 1280,
        "height": 562
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6428806388307222049&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eastgate-shopping-center",
      "poi_latitude": "31.7614986",
      "poi_longitude": "-106.3565347",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3b63-711e-8552-cfdc20ba5bff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3b63-711e-8552-cfdc20ba5bff",
        "storage_key": "property/6767906449165624/019cfb47-3b63-711e-8552-cfdc20ba5bff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBcepKsFb54YRIV7QUFm1N1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c31061bd-6b2f-4be7-ab67-41118de7d004",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Los Bandidos De Carlos & Mickey's",
      "poi_type": "Restaurants",
      "poi_address": "1310 Magruder St, El Paso, TX 79925, USA",
      "poi_short_description": "Tex-Mex eatery known for its lively atmosphere,  oversized margaritas & mariachi music.",
      "poi_long_description": "People say this Mexican restaurant serves delicious pork carnitas, tamales, and margaritas. They also highlight the fun, lively atmosphere with live music and the attentive, friendly service.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-4e51-7019-a8ee-7fd969e59847.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4e51-7019-a8ee-7fd969e59847",
        "storage_key": "property/6767906449165624/019d7913-4e51-7019-a8ee-7fd969e59847.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.carlosandmickeys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17218287806100256746&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "los-bandidos-de-carlos-mickey-s",
      "poi_latitude": "31.786285",
      "poi_longitude": "-106.417029",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-778-3323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3b63-711e-8552-cbdef0b6904a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3b63-711e-8552-cbdef0b6904a",
        "storage_key": "property/6767906449165624/019cfb47-3b63-711e-8552-cbdef0b6904a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkzopHEha54YR6rcLg4il8-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_7b7daef5-9366-4fd8-ae75-177eacd108e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Andale Mexican Restaurant and Cantina",
      "poi_type": "Restaurants",
      "poi_address": "9201 Gateway Blvd W, El Paso, TX 79925, USA",
      "poi_short_description": "Traditional dishes & creative cocktails served in a festive atmosphere with live music nights.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos, enchiladas, and guacamole. They also highlight the festive atmosphere with live mariachi music and the excellent service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-56f7-70e8-bfb6-6769cb1e342e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-56f7-70e8-bfb6-6769cb1e342e",
        "storage_key": "property/6767906449165624/019d7913-56f7-70e8-bfb6-6769cb1e342e.webp",
        "width": 1125,
        "height": 656
      },
      "poi_business_url": "http://www.andalemexicanrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9586712556564435642&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "andale-mexican-restaurant-and-cantina",
      "poi_latitude": "31.7658402",
      "poi_longitude": "-106.3651468",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-590-5999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3b63-711e-8552-cbdef0b6904a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3b63-711e-8552-cbdef0b6904a",
        "storage_key": "property/6767906449165624/019cfb47-3b63-711e-8552-cbdef0b6904a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIxHclz5b54YRutLMEUfYCoU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_587ca1ba-08e7-480e-925c-94cf17af8afb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Cattle Baron",
      "poi_type": "Restaurants",
      "poi_address": "1700 Airway Blvd, El Paso, TX 79925, USA",
      "poi_short_description": "Longtime Western-themed restaurant providing steak, seafood & cocktails, with a salad bar & takeout.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, chicken fried steak, and burgers. They also highlight the excellent salad bar, good value, and friendly service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-5a8c-7039-8757-c5be60cba8d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5a8c-7039-8757-c5be60cba8d3",
        "storage_key": "property/6767906449165624/019d7913-5a8c-7039-8757-c5be60cba8d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cattlebaron.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15955167058316646195&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cattle-baron",
      "poi_latitude": "31.7922114",
      "poi_longitude": "-106.3949505",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-779-6633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3b63-711e-8552-cbdef0b6904a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3b63-711e-8552-cbdef0b6904a",
        "storage_key": "property/6767906449165624/019cfb47-3b63-711e-8552-cbdef0b6904a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJayh9Rlha54YRM1f6yucjbN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_f96f71a1-6385-4bb4-88e1-bd4ae4117e01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Red Lobster",
      "poi_type": "Restaurants",
      "poi_address": "IN FRONT OF BESTBUY, 1860 Joe Battle Blvd, El Paso, TX 79936, USA",
      "poi_short_description": "Well-known chain for seafood dinners, including lobster, shrimp, crab and salmon, plus wood-fired options.",
      "poi_long_description": "People say this seafood restaurant serves delicious salmon, shrimp, and crab boils. They highlight the fresh, hot biscuits and the attentive, friendly service. They also like the clean and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-5cab-738c-af33-3b704b7c3af2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5cab-738c-af33-3b704b7c3af2",
        "storage_key": "property/6767906449165624/019d7913-5cab-738c-af33-3b704b7c3af2.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "https://www.redlobster.com/seafood-restaurants/locations/tx/el-paso/1860-joe-battle-blvd",
      "poi_directions_map_url": "https://maps.google.com/?cid=17186527393743258314&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-lobster",
      "poi_latitude": "31.757041",
      "poi_longitude": "-106.266803",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-849-9844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3b63-711e-8552-cbdef0b6904a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3b63-711e-8552-cbdef0b6904a",
        "storage_key": "property/6767906449165624/019cfb47-3b63-711e-8552-cbdef0b6904a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEWcSLAlE54YRykKWQpvPgu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_dc156c8f-a2da-40b9-8afd-26a107d41f0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Kona Grill - El Paso",
      "poi_type": "Restaurants",
      "poi_address": "8889 Gateway Blvd W #1740, El Paso, TX 79925, USA",
      "poi_short_description": "Sleek chain with a broad New American menu including low-calorie options, plus sushi & cocktails.",
      "poi_long_description": "People say this restaurant serves delicious sushi, burgers, and a variety of other dishes, including a popular Fire Dragon Roll. They highlight the great happy hour deals, especially on drinks and appetizers, and the fun, lively atmosphere. They also like the attentive and friendly service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-6329-76ce-95c4-2bcaa779eb31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6329-76ce-95c4-2bcaa779eb31",
        "storage_key": "property/6767906449165624/019d7913-6329-76ce-95c4-2bcaa779eb31.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://konagrill.com/locations?locations=El-Paso,79925",
      "poi_directions_map_url": "https://maps.google.com/?cid=14237360735858135457&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kona-grill-el-paso",
      "poi_latitude": "31.7699659",
      "poi_longitude": "-106.3724955",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-249-3803",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3b63-711e-8552-cbdef0b6904a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3b63-711e-8552-cbdef0b6904a",
        "storage_key": "property/6767906449165624/019cfb47-3b63-711e-8552-cbdef0b6904a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJke4HnBdb54YRoRHrDyhElcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_70488895-f5e6-4810-b13d-97fbc28e5d3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Towne Centre At Cielo Vista",
      "poi_type": "Restaurants",
      "poi_address": "Hawkins Blvd, El Paso, TX 79915, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2479982028349601125&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "towne-centre-at-cielo-vista",
      "poi_latitude": "31.7749812",
      "poi_longitude": "-106.3800815",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3b63-711e-8552-cfdc20ba5bff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3b63-711e-8552-cfdc20ba5bff",
        "storage_key": "property/6767906449165624/019cfb47-3b63-711e-8552-cfdc20ba5bff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFdn1qBNb54YRZXUh6YOqaiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_aed346b3-048e-414e-bed2-7d68633521bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Ascarate Park Pool & Aquatics",
      "poi_type": "Entertainment",
      "poi_address": "6900 Delta Dr, El Paso, TX 79905, USA",
      "poi_short_description": "Huge outdoor public pool open seasonally for swimming, diving, and chilling.",
      "poi_long_description": "People say this outdoor swimming pool offers a large pool with varying depths, a children's pool, and a ninja warrior course. They also highlight the park's all-abilities park, sitting areas, and opportunities for fishing and picnicking.\n\nOther reviews mention the hours can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-6795-70ac-b54e-6d76a20a09af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6795-70ac-b54e-6d76a20a09af",
        "storage_key": "property/6767906449165624/019d7913-6795-70ac-b54e-6d76a20a09af.webp",
        "width": 1280,
        "height": 515
      },
      "poi_business_url": "https://www.epcountyparks.com/ascarate-pool",
      "poi_directions_map_url": "https://maps.google.com/?cid=12124686360001813446&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ascarate-park-pool-aquatics",
      "poi_latitude": "31.7558416",
      "poi_longitude": "-106.4040658",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-273-3501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3b7c-7739-9706-64b3b67daa87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3b7c-7739-9706-64b3b67daa87",
        "storage_key": "property/6767906449165624/019cfb47-3b7c-7739-9706-64b3b67daa87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrU2-oKJb54YRxpvuTAGKQ6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "swimming_pool"
    },
    {
      "id": "custom_d24a4724-bb55-4de2-a5f6-51a78b20f456",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Crime Victims Memorial Park",
      "poi_type": "Entertainment",
      "poi_address": "610 San Paulo Dr, El Paso, TX 79907, USA",
      "poi_short_description": "Children are welcome at this park that's also home to a library.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-71e5-777f-9bf1-936e024f71d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-71e5-777f-9bf1-936e024f71d7",
        "storage_key": "property/6767906449165624/019d7913-71e5-777f-9bf1-936e024f71d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://crime-park.edan.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4516209474846300634&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "crime-victims-memorial-park",
      "poi_latitude": "31.7408325",
      "poi_longitude": "-106.3450914",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3b20-732d-b437-b255a51ef10b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3b20-732d-b437-b255a51ef10b",
        "storage_key": "property/6767906449165624/019cfb47-3b20-732d-b437-b255a51ef10b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUgpXFVD54YR2pl355bMrD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a1f0e663-54ca-4d94-8dcd-a667accbb0d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "El Paso Municipal Rose Garden",
      "poi_type": "Entertainment",
      "poi_address": "3418 Aurora Ave, El Paso, TX 79930, USA",
      "poi_short_description": "Peaceful oasis featuring different varieties of roses and other flowers, with benches and a fountain.",
      "poi_long_description": "People say this garden offers a large selection of award-winning roses and other flowers. They highlight the peaceful and serene atmosphere, and the beautiful aroma. They also like the well-maintained grounds and the availability of shade and covered seating. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-7898-779f-9624-942abaad9a2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7898-779f-9624-942abaad9a2d",
        "storage_key": "property/6767906449165624/019d7913-7898-779f-9624-942abaad9a2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elpasotexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16475470708097522831&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-paso-municipal-rose-garden",
      "poi_latitude": "31.7928257",
      "poi_longitude": "-106.4530369",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3b7c-7739-9706-64b3b67daa87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3b7c-7739-9706-64b3b67daa87",
        "storage_key": "property/6767906449165624/019cfb47-3b7c-7739-9706-64b3b67daa87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT37fuJJZ54YRj5yBd1GhpOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_9d40369f-591d-427b-90ca-b7fc19acd680",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Magoffin Home State Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "1120 Magoffin Ave, El Paso, TX 79901, USA",
      "poi_short_description": "Adobe Territorial home of a pioneering multicultural family, now open for house & garden tours.",
      "poi_long_description": "People say this historic site offers interesting tours and beautiful backdrops for photos. They highlight the knowledgeable and passionate staff, and the friendly and conversational manner of the tour guides. They also like the family-friendly events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-705a-76b4-b368-2548b88cf4f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-705a-76b4-b368-2548b88cf4f5",
        "storage_key": "property/6767906449165624/019d7913-705a-76b4-b368-2548b88cf4f5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.visitmagoffinhome.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2982071049809010811&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "magoffin-home-state-historic-site",
      "poi_latitude": "31.7624871",
      "poi_longitude": "-106.4769802",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-533-5147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3b7c-7739-9706-64b3b67daa87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3b7c-7739-9706-64b3b67daa87",
        "storage_key": "property/6767906449165624/019cfb47-3b7c-7739-9706-64b3b67daa87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtxcA5AVZ54YRe6DX8tFxYik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_place"
    },
    {
      "id": "custom_e41c6d5a-efe6-4684-aa8c-3383e7342c40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Old Fort Bliss Replica Cultural Center",
      "poi_type": "Entertainment",
      "poi_address": "5054 Pershing Rd, El Paso, TX 79925, USA",
      "poi_short_description": "Family-friendly spot highlighting history with tanks and a variety of events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-7175-709b-8285-62f8aafbdd89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7175-709b-8285-62f8aafbdd89",
        "storage_key": "property/6767906449165624/019d7913-7175-709b-8285-62f8aafbdd89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bliss.armymwr.com/programs/old-fort-bliss-replica-cultural-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=4245832940313559171&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-fort-bliss-replica-cultural-center",
      "poi_latitude": "31.8000486",
      "poi_longitude": "-106.4266952",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-588-8482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3bbe-757e-999f-ed93d19caa42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3bbe-757e-999f-ed93d19caa42",
        "storage_key": "property/6767906449165624/019cfb47-3bbe-757e-999f-ed93d19caa42.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5-duCBda54YRg8AKV5A67Do",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c8dd0072-233c-4331-8c7f-52df0b4ece4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Cinemark Cielo Vista Mall 14 and XD",
      "poi_type": "Entertainment",
      "poi_address": "8401C Gateway Blvd W, El Paso, TX 79925, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "People say this movie theater offers high-quality movies with clear picture and great sound. They highlight the comfortable seats, clean theaters, and friendly staff. They also like the convenient location near the mall and bus station.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-7eaa-7288-bba8-5decfff0839f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7eaa-7288-bba8-5decfff0839f",
        "storage_key": "property/6767906449165624/019d7913-7eaa-7288-bba8-5decfff0839f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-el-paso/cinemark-cielo-vista-mall-14-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5NTEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6797349130704012432&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinemark-cielo-vista-mall-14-and-xd",
      "poi_latitude": "31.7784184",
      "poi_longitude": "-106.3828475",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-771-0072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-9e44-718b-a9e3-e1853fca4f51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-9e44-718b-a9e3-e1853fca4f51",
        "storage_key": "property/6767906449165624/019d7913-9e44-718b-a9e3-e1853fca4f51.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJTztXy1hb54YRkETsPQUJVV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_5b74292f-75cc-4fd1-99bb-f61ad5ca5ee6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "Butterfield Trail Golf Club",
      "poi_type": "Entertainment",
      "poi_address": "1858 Cottonwoods Dr, El Paso, TX 79925, USA",
      "poi_short_description": "18-hole municipal golf course featuring challenging holes, lessons, an eatery & mountain views.",
      "poi_long_description": "People say this golf club offers a fun and challenging course with beautiful views and a layout that is enjoyable to play. They also highlight the helpful staff, good food, and drinks.\n\nOther reviews mention the course conditions can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d7913-7a09-7628-9982-cf77a24db038.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7a09-7628-9982-cf77a24db038",
        "storage_key": "property/6767906449165624/019d7913-7a09-7628-9982-cf77a24db038.webp",
        "width": 1280,
        "height": 948
      },
      "poi_business_url": "http://www.butterfieldtrailgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8017814605017103407&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "butterfield-trail-golf-club",
      "poi_latitude": "31.823357",
      "poi_longitude": "-106.3380821",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-772-1038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-3b7c-7739-9706-64b3b67daa87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb47-3b7c-7739-9706-64b3b67daa87",
        "storage_key": "property/6767906449165624/019cfb47-3b7c-7739-9706-64b3b67daa87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwygRY7Ja54YRL7z7Luf_RG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "custom_f32f787a-e3e8-436a-a5a2-425f6869c270",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "poi_name": "The Fountains at Farrah",
      "poi_type": "Restaurants",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "the-fountains-at-farrah",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f85d43e2bafc221cf581db4d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_40058352309a45595530c2e2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_9d8bc3e6e08c4668fd41920a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_5c38c31bf1cca54ab1589cf2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_beea3f202e2c3b5eabbbdcc5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_27a3f85c5c5fba1aefc6c98f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_21c8797e-de8b-4e95-af63-bf707622daaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "rating": "5.0",
      "name": "",
      "text": "I'm in the military. This place works with you if you go to the field but as of a year ago they added a pay online option. The staff is friendly and maintaince is quick of needed. As a parent, I love this place more because they have a little park. Two pools and compared to other places, one of the cheaper pet rents. Also, it's quite.",
      "date": "",
      "title": "Shadow Ridge"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_8b52cb4a-9d45-4495-9723-531a97327558",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-da07-77fc-9a37-7f5cf98e81fe.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of the swimming pool area with lounge chairs and tables.",
        "public_id": "019cfb47-da07-77fc-9a37-7f5cf98e81fe",
        "storage_key": "property/6767906449165624/019cfb47-da07-77fc-9a37-7f5cf98e81fe.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Shadow Ridge Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=62ff613eda27981bced0f465"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-796c-753a-b356-93df370f460f",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "shadow-ridge-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624"
    },
    {
      "lead_collector_id": "019cf79e-79e4-7129-a5a6-d2812f001c60",
      "lead_source": "LANDING_PAGE",
      "name": "shadow-ridge-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "apartments-with-pool-el-paso-tx",
      "search_query": "apartments with pool el paso tx",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in El Paso, TX",
      "h2_subtitle": "Discover luxurious apartments with a pool in El Paso, TX. Enjoy resort-style living with our shimmering pool and modern amenities.",
      "page_copy": "Welcome to Shadow Ridge Apts., your ideal choice for apartments with a pool in El Paso, TX. Nestled in the vibrant Stonehaven neighborhood, our community offers spacious one, two, and three-bedroom floor plans designed to complement your lifestyle. Whether you're taking a dip in our pristine pool or breaking a sweat in the state-of-the-art fitness center, you'll find there's no shortage of ways to enjoy leisure and recreation right at home.\n\nExperience convenience and comfort with our selection of premium amenities including a volleyball court, 24-hour access facilities, and in-unit washers and dryers. Shadow Ridge Apts. combines modern living with the charm of El Paso, making it an exceptional place to call home. With onsite maintenance service and a community focused on providing exceptional living, your dream apartment with a pool awaits you at Shadow Ridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in El Paso, TX",
      "seo_description": "Explore Shadow Ridge Apts. in El Paso, TX offering beautiful apartments with a pool and exceptional amenities in the Stonehaven neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-stonehaven",
      "search_query": "fitness center apartments stonehaven",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Stonehaven",
      "h2_subtitle": "Enjoy fitness center amenities at Shadow Ridge Apartments in Stonehaven. Discover the perfect blend of comfort and wellness.",
      "page_copy": "If you're searching for fitness center apartments in Stonehaven, look no further than Shadow Ridge Apts. Located in El Paso's lively Stonehaven neighborhood, our community promises more than just a place to live; it offers a lifestyle centered on wellness and comfort. Our state-of-the-art fitness center is the centerpiece of our amenities, providing residents with a convenient and well-equipped space to stay active and healthy.\n\nBeyond the fitness facilities, Shadow Ridge Apts. features spacious one, two, and three-bedroom floor plans designed to cater to your every need. Enjoy access to a shimmering pool for relaxation, a volleyball court for some friendly competition, and in-unit conveniences like washers and dryers. With 24-hour access and onsite maintenance, Shadow Ridge ensures your apartment living is as seamless and enjoyable as possible. Explore the best of Stonehaven living with us!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Stonehaven",
      "seo_description": "Find the ideal fitness center apartment in Stonehaven at Shadow Ridge Apts., featuring modern amenities and spacious living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-washer-dryer-el-paso",
      "search_query": "apartments with in-unit washer dryer el paso",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer Dryer in El Paso",
      "h2_subtitle": "Enjoy the convenience of in-unit washer and dryer at Shadow Ridge Apartments in El Paso. Discover a lifestyle of ease and comfort.",
      "page_copy": "Discover the perfect balance of convenience and luxury at Shadow Ridge Apts., where we offer apartments with in-unit washer and dryer in El Paso. Situated in the vibrant Stonehaven neighborhood, our community provides an effortless lifestyle with thoughtfully designed one, two, and three-bedroom floor plans that cater to your every need.\n\nIn addition to having a washer and dryer right in your apartment, you'll also enjoy a host of premium amenities. Take advantage of our shimmering pool, hit the volleyball court, or maintain your exercise routine in our state-of-the-art fitness center. With maintenance services available on-site and 24-hour access, living at Shadow Ridge means enjoying a community that feels like home, where all your necessities are at your fingertips.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts. with In-Unit Washer Dryer in El Paso",
      "seo_description": "Experience convenience at Shadow Ridge Apts. in El Paso with in-unit washer and dryer, plus modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "shadow-ridge-apartments-with-air-conditioning",
      "search_query": "shadow ridge apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Shadow Ridge Apartments with Air Conditioning",
      "h2_subtitle": "Experience cool comfort at Shadow Ridge Apartments. Stay refreshed with our modern air conditioning in every unit.",
      "page_copy": "Embrace the ideal living environment at Shadow Ridge Apartments, where air conditioning comes standard in every unit. Located in El Paso's thriving Stonehaven neighborhood, our community offers a refreshing retreat from the Texas heat. Each one, two, or three-bedroom apartment is equipped with the latest air conditioning systems, ensuring that you stay comfortable year-round.\n\nShadow Ridge Apartments combines practicality with luxury, featuring not only air-conditioned living spaces but also a range of exceptional amenities. Enjoy a leisurely swim in our sparkling pool or work out in our fully-equipped fitness center. With conveniences like in-unit washers and dryers, and a volleyball court for recreational fun, Shadow Ridge provides a vibrant community atmosphere where every day feels like a vacation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Shadow Ridge Apts. with Air Conditioning",
      "seo_description": "Stay cool at Shadow Ridge Apartments in El Paso with air conditioning, spacious layouts, and top-notch amenities in the Stonehaven community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "apartments-with-pet-washing-station-79925",
      "search_query": "apartments with pet washing station 79925",
      "category": "Amenity",
      "h1_title": "Apartments with Pet Washing Station in 79925",
      "h2_subtitle": "Shadow Ridge Apartments in 79925 offers dedicated pet washing stations. Discover pet-friendly living at its best.",
      "page_copy": "Welcome to Shadow Ridge Apartments, the perfect community for pet lovers in the 79925 area. Our pet-friendly apartments not only welcome your furry companions but also offer an exclusive pet washing station, making it easy to keep your pets clean and pampered. Located in El Paso's inviting Stonehaven neighborhood, Shadow Ridge is designed with both you and your pets in mind.\n\nBeyond the pet washing amenity, our one, two, or three-bedroom apartments feature conveniences like in-unit washers and dryers and air conditioning. Residents also enjoy access to recreational facilities such as a shimmering pool and state-of-the-art fitness center. At Shadow Ridge Apartments, you and your pets can enjoy a lifestyle full of comfort and leisure, where every member of your household feels right at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts. with Pet Washing Station in 79925",
      "seo_description": "Discover pet-friendly living at Shadow Ridge Apts. in El Paso (79925) equipped with a convenient pet washing station and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-el-paso-tx",
      "search_query": "1 bedroom apartments el paso tx",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in El Paso, TX",
      "h2_subtitle": "Explore comfortable 1 bedroom apartments at Shadow Ridge in El Paso, TX. Perfect for a cozy and convenient lifestyle.",
      "page_copy": "Shadow Ridge Apartments offers ideal 1 bedroom living spaces tailored to meet your needs in El Paso, TX. Nestled in the vibrant Stonehaven neighborhood, our community provides a sanctuary of comfort and style. Whether you're new to the area or seeking a change, our thoughtfully designed 1 bedroom apartments deliver everything you need for a modern lifestyle.\n\nEach apartment comes equipped with conveniences such as air conditioning and in-unit washers and dryers, making daily life easier. Enjoy the benefits of community amenities like a sparkling pool and a state-of-the-art fitness center, enhancing your living experience. At Shadow Ridge Apartments, discover a welcoming community that offers more than just an apartment—it's a place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in El Paso, TX",
      "seo_description": "Find your perfect 1 bedroom apartment at Shadow Ridge in El Paso, TX. Enjoy modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-stonehaven",
      "search_query": "2 bedroom apartments stonehaven",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Stonehaven",
      "h2_subtitle": "Discover spacious 2 bedroom apartments at Shadow Ridge in the Stonehaven community. Perfect for family or shared living.",
      "page_copy": "Experience the perfect blend of comfort and convenience with the 2 bedroom apartments at Shadow Ridge, located in the sought-after Stonehaven community. These well-designed spaces are ideal for families, roommates, or anyone in need of extra room. Each apartment features modern amenities and stylish interiors, offering a welcoming atmosphere right in the heart of El Paso.\n\nAt Shadow Ridge, you'll enjoy in-unit washers and dryers, air conditioning, and access to an array of community amenities. Take advantage of our shimmering pool, fully-equipped fitness center, and other outdoor recreational areas. With the vibrant neighborhood of Stonehaven at your doorstep, Shadow Ridge Apartments promises a home where you can truly thrive and enjoy a fulfilling lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Stonehaven",
      "seo_description": "Explore 2 bedroom apartments at Shadow Ridge in Stonehaven. Enjoy modern living with ample space and top amenities in a prime El Paso location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-79925",
      "search_query": "3 bedroom apartments near 79925",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 79925",
      "h2_subtitle": "Shadow Ridge offers spacious 3 bedroom apartments near 79925. Ideal for families seeking comfort and convenience in El Paso.",
      "page_copy": "Shadow Ridge Apartments presents a perfect opportunity for families and groups seeking spacious 3 bedroom living arrangements near the 79925 area. Nestled in the vibrant Stonehaven neighborhood, our apartments offer the perfect blend of comfort, style, and practicality. Enjoy modern layouts that ensure ample space and privacy for every family member.\n\nEach 3 bedroom unit is designed with your needs in mind, featuring in-unit washers and dryers and air conditioning. Residents can also take full advantage of a range of community amenities, including a shimmering pool and a fitness center. Discover a welcoming community at Shadow Ridge Apartments, where convenience and lifestyle come together seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 79925",
      "seo_description": "Find spacious 3 bedroom apartments near 79925 at Shadow Ridge. Experience family-friendly living with top amenities in El Paso.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "apartments-near-uacj-icb-el-paso",
      "search_query": "apartments near UACJ ICB El Paso",
      "category": "School",
      "h1_title": "Apartments Near UACJ ICB El Paso",
      "h2_subtitle": "Discover top apartments near UACJ ICB at Shadow Ridge. Convenient living close to El Paso's educational hub.",
      "page_copy": "For students and professionals seeking convenience and comfort, Shadow Ridge Apartments offers an exceptional living experience near UACJ ICB in El Paso. Our community is perfectly located, providing easy access to the University and surrounding educational facilities. Our well-appointed apartments offer the ideal combination of style, utility, and proximity to UACJ ICB.\n\nResidents at Shadow Ridge can enjoy a variety of modern amenities including resort-style facilities like a shimmering pool and state-of-the-art fitness center. Each apartment comes equipped with in-unit washers and dryers and air conditioning to enhance everyday living. With Shadow Ridge, experience quality living right near UACJ ICB, making your academic or professional journey both comfortable and convenient.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UACJ ICB El Paso",
      "seo_description": "Explore apartments near UACJ ICB at Shadow Ridge in El Paso. Enjoy convenient, modern living just steps from educational excellence.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "el-paso-community-college-valle-verde-apartments",
      "search_query": "El Paso Community College Valle Verde apartments",
      "category": "School",
      "h1_title": "Apartments by El Paso Community College Valle Verde",
      "h2_subtitle": "Shadow Ridge offers convenient apartments near El Paso Community College Valle Verde. Ideal for students and staff seeking easy access.",
      "page_copy": "Located just a short drive from El Paso Community College Valle Verde, Shadow Ridge Apartments provides an ideal living solution for students and staff looking for convenience and modern amenities. Our community offers a range of apartment options that cater to various lifestyles, ensuring a comfortable and conducive environment for both studying and relaxing.\n\nShadow Ridge Apartments boasts facilities such as a state-of-the-art fitness center, a sparkling pool, and recreational spaces that allow you to unwind after a long day. Each apartment is equipped with features like in-unit washers and dryers and air conditioning, making everyday life easier. Choose Shadow Ridge as your home near El Paso Community College Valle Verde and enjoy a perfect blend of style, comfort, and accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near El Paso Community College Valle Verde",
      "seo_description": "Find ideal apartments near El Paso Community College Valle Verde at Shadow Ridge. Enjoy convenient, stylish living options in El Paso.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "apartments-by-institute-of-social-sciences-el-paso",
      "search_query": "apartments by Institute of Social Sciences El Paso",
      "category": "School",
      "h1_title": "Apartments by Institute of Social Sciences El Paso",
      "h2_subtitle": "Discover convenient apartments by the Institute of Social Sciences in El Paso. Shadow Ridge offers prime location and comfort.",
      "page_copy": "Shadow Ridge Apartments offers prime living opportunities near the Institute of Social Sciences in El Paso. Strategically located to provide easy access for students and professionals, our community embodies comfort and convenience. Enjoy modern, well-appointed living spaces that help foster both personal and academic success.\n\nOur community features a range of amenities such as a sparkling pool, state-of-the-art fitness center, and ample recreational facilities. Each apartment is designed for convenience with in-unit washers and dryers and air conditioning, making it a perfect fit for your busy lifestyle. Make Shadow Ridge Apartments your home and enjoy being just minutes away from the Institute of Social Sciences in El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Institute of Social Sciences El Paso",
      "seo_description": "Find apartments near the Institute of Social Sciences in El Paso at Shadow Ridge. Experience comfort and proximity to educational facilities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "rent-near-instituto-de-ciencias-biomedicas-el-paso",
      "search_query": "rent near Instituto de Ciencias Biomédicas",
      "category": "School",
      "h1_title": "Rent Near Instituto de Ciencias Biomédicas",
      "h2_subtitle": "Explore rental opportunities near Instituto de Ciencias Biomédicas. Shadow Ridge offers comfort and proximity in El Paso.",
      "page_copy": "Shadow Ridge Apartments provides an excellent choice for those looking to rent near the Instituto de Ciencias Biomédicas in El Paso. Our community combines convenience with modern living, making it an ideal location for students and professionals. Enjoy the peace of mind of being close to educational centers while experiencing top-notch facilities.\n\nAt Shadow Ridge, residents can take advantage of a variety of amenities, including a shimmering pool, a fully-equipped fitness center, and on-site maintenance. Apartments come with essential features such as in-unit washers and dryers and microwaves, ensuring a comfortable lifestyle. Embrace the opportunity to live close to the Instituto de Ciencias Biomédicas and benefit from a thriving community atmosphere at Shadow Ridge Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rent Near Instituto de Ciencias Biomédicas El Paso",
      "seo_description": "Discover convenient rental options near Instituto de Ciencias Biomédicas in El Paso at Shadow Ridge. Enjoy access, comfort, and community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "apartments-close-to-technological-institute-ciudad-juarez",
      "search_query": "apartments close to Technological Institute Ciudad Juárez",
      "category": "School",
      "h1_title": "Apartments Close to Technological Institute Ciudad Juárez",
      "h2_subtitle": "Find convenient apartments near Technological Institute Ciudad Juárez. Shadow Ridge provides perfect access and modern amenities.",
      "page_copy": "Shadow Ridge Apartments offers the ideal solution for those seeking living spaces close to the Technological Institute Ciudad Juárez. With our strategic location in El Paso, residents enjoy easy access to cross-border educational opportunities while residing in a vibrant community. Experience the peace of living within a short distance of your academic pursuits.\n\nOur apartments are designed with convenience and comfort in mind, featuring in-unit washers and dryers, microwaves, and air conditioning. The community boasts amenities like a stunning pool and a cutting-edge fitness center, perfect for unwinding after a busy day. Reside at Shadow Ridge and enjoy seamless commuting options and a lively community spirit near the Technological Institute Ciudad Juárez.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Technological Institute Ciudad Juárez",
      "seo_description": "Explore apartments near Technological Institute Ciudad Juárez at Shadow Ridge. Benefit from convenient living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "apartments-near-imss-hospital-general-regional-no-2-stonehaven",
      "search_query": "apartments near IMSS Hospital General Regional No. 2 in Stonehaven",
      "category": "Hospital",
      "h1_title": "Apartments Near IMSS Hospital in Stonehaven",
      "h2_subtitle": "Discover comfortable apartments near IMSS Hospital General Regional No. 2 in Stonehaven. Shadow Ridge offers convenience and modern living.",
      "page_copy": "Located in the vibrant Stonehaven neighborhood, Shadow Ridge Apartments provides an ideal place to live near IMSS Hospital General Regional No. 2. Our community combines the benefits of a prime location with a variety of modern amenities, making it perfect for healthcare professionals and families alike. Enjoy the ease of being just moments away from the hospital and the bustling cultural activities of Stonehaven.\n\nThe apartments at Shadow Ridge come equipped with conveniences such as in-unit washers and dryers, microwaves, and a host of community features. Relax by the pool, stay fit with our state-of-the-art gym, or challenge friends at the volleyball court—all within your reach. Choose Shadow Ridge Apartments and take advantage of a perfect blend of proximity to essential services and exceptional community living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near IMSS Hospital Stonehaven",
      "seo_description": "Find comfort and convenience at Shadow Ridge Apartments, near IMSS Hospital General Regional No. 2 in Stonehaven. Enjoy modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "el-paso-apartments-close-to-william-beaumont-army-medical-center",
      "search_query": "El Paso apartments close to William Beaumont Army Medical Center",
      "category": "Hospital",
      "h1_title": "El Paso Apartments Near William Beaumont AMC",
      "h2_subtitle": "Explore apartments close to William Beaumont Army Medical Center. Shadow Ridge offers accessibility and comfort in El Paso.",
      "page_copy": "Shadow Ridge Apartments is an excellent choice for those seeking proximity to the William Beaumont Army Medical Center in El Paso. Ideally situated, our community provides effortless access to this critical healthcare facility, making it perfect for military personnel and healthcare professionals. Experience the convenience of living near your place of work while enjoying a serene residential environment.\n\nOur thoughtfully designed apartments come with amenities that enhance daily living, including in-unit washers and dryers and modern kitchen appliances. Residents can unwind with our resort-style amenities like a sparkling pool and a well-equipped fitness center. Choose Shadow Ridge Apartments to combine residential comfort with the strategic advantage of being close to William Beaumont Army Medical Center, enveloped within a welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "El Paso Apartments Near William Beaumont AMC",
      "seo_description": "Find seamless living at Shadow Ridge Apartments, close to William Beaumont Army Medical Center in El Paso. Enjoy modern amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "apartments-close-to-memorial-park-el-paso",
      "search_query": "apartments close to memorial park el paso",
      "category": "Park",
      "h1_title": "Apartments Close to Memorial Park, El Paso",
      "h2_subtitle": "Discover apartments near Memorial Park in El Paso. Shadow Ridge offers a blend of nature and comfort.",
      "page_copy": "Shadow Ridge Apartments offers an exceptional lifestyle for those wanting to live near the scenic Memorial Park in El Paso. This prime location allows residents to enjoy the lush greenery and wide-open spaces of the park, perfect for outdoor activities or leisurely strolls. Shadow Ridge provides an excellent balance of nature and urban living, with Memorial Park just a short distance away.\n\nOur community features a range of amenities designed for comfort and convenience, such as in-unit washers and dryers and fully-equipped kitchens. The on-site volleyball court, swimming pool, and fitness center offer plenty of recreational options. Choose Shadow Ridge Apartments to enjoy the tranquility of being near Memorial Park and the vibrancy of El Paso's dynamic cultural scene.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Memorial Park, El Paso",
      "seo_description": "Live at Shadow Ridge Apartments near Memorial Park, El Paso, and enjoy resort-style amenities with easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "apartments-near-parque-publico-federal-el-chamizal-tx",
      "search_query": "apartments near parque público federal el chamizal tx",
      "category": "Park",
      "h1_title": "Apartments Near El Chamizal Park, TX",
      "h2_subtitle": "Find the perfect apartment near Parque Público Federal El Chamizal in TX. Shadow Ridge offers an ideal living experience.",
      "page_copy": "Shadow Ridge Apartments in El Paso is situated perfectly for anyone wanting easy access to Parque Público Federal El Chamizal. This location makes enjoying the cultural events and scenic beauty of the park more convenient than ever. Living at Shadow Ridge means you can blend the bustling city life with the tranquility of this significant local attraction.\n\nAt Shadow Ridge, we cater to your every need with amenities like in-unit washers and dryers, a modern kitchen, and luxurious recreational facilities. Spend weekends by the shimmering pool or stay active at our top-notch fitness center. Discover comfortable and convenient living at Shadow Ridge Apartments, where you're always close to the charms of El Chamizal Park and the thriving community of El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near El Chamizal Park, TX",
      "seo_description": "Experience ideal living at Shadow Ridge Apartments near El Chamizal Park, TX. Enjoy accessibility and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "apartments-by-moretto-2-stonehaven",
      "search_query": "apartments by moretto 2 stonehaven",
      "category": "Park",
      "h1_title": "Apartments Near Moretto 2 in Stonehaven",
      "h2_subtitle": "Discover charming apartments by Moretto 2, located in the Stonehaven neighborhood. Enjoy convenient living at Shadow Ridge Apts.",
      "page_copy": "Shadow Ridge Apartments offers the perfect home for those seeking proximity to Moretto 2 in the Stonehaven neighborhood. Experience the convenience of living in a thriving community that perfectly balances urban amenities with neighborhood charm. Residents can enjoy quick access to local attractions while savoring the tranquility of Stonehaven.\n\nOur one, two, and three-bedroom apartments come with modern features such as in-unit washers and dryers and spacious layouts. Unwind using our resort-style amenities like the refreshing pool and well-equipped fitness center. At Shadow Ridge Apartments, you're just moments away from Moretto 2, offering an ideal location that complements an active and vibrant lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Moretto 2 Stonehaven",
      "seo_description": "Live at Shadow Ridge Apartments near Moretto 2 in Stonehaven, offering comfort, amenities, and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "apartments-close-to-marty-robbins-park-el-paso",
      "search_query": "apartments close to marty robbins park el paso",
      "category": "Park",
      "h1_title": "Apartments Close to Marty Robbins Park, El Paso",
      "h2_subtitle": "Explore apartments near Marty Robbins Park in El Paso. Shadow Ridge offers a convenient and comfortable living experience.",
      "page_copy": "Located a short drive from Marty Robbins Park, Shadow Ridge Apartments provides an ideal living option for those looking to stay close to this beloved El Paso destination. Enjoy the variety of recreational activities and events hosted at the park, knowing you're just minutes away from home. \n\nAt Shadow Ridge, we offer a plethora of amenities designed for your ease and enjoyment, including in-unit washers and dryers, a gleaming pool, and a modern fitness center. Choose from spacious one, two, or three-bedroom options, each designed with your lifestyle in mind. Embrace the perfect blend of convenience and leisure at Shadow Ridge Apartments, where Marty Robbins Park is practically at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Marty Robbins Park, El Paso",
      "seo_description": "Discover Shadow Ridge Apartments near Marty Robbins Park, El Paso, featuring modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "apartments-near-blackie-chesher-park-79925",
      "search_query": "apartments near blackie chesher park 79925",
      "category": "Park",
      "h1_title": "Apartments Near Blackie Chesher Park 79925",
      "h2_subtitle": "Discover modern apartments near Blackie Chesher Park, nestled in the 79925 area. Enjoy vibrant community living at Shadow Ridge.",
      "page_copy": "Shadow Ridge Apartments offers a prime location near Blackie Chesher Park in the 79925 zip code of El Paso. This proximity allows residents to easily enjoy the park's sprawling green spaces and various recreational facilities, perfect for weekend outings or daily strolls.\n\nResidents of Shadow Ridge can choose from a selection of spacious one, two, or three-bedroom floor plans, each equipped with modern conveniences like in-unit washers and dryers. Enjoy a refreshing dip in our resort-style pool or stay active in our fully equipped gym. With easy access to Blackie Chesher Park, living at Shadow Ridge Apartments combines the best of outdoor recreation and urban convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Blackie Chesher Park 79925",
      "seo_description": "Find your new home at Shadow Ridge Apartments near Blackie Chesher Park, 79925. Enjoy comfort and convenience in El Paso.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165624",
      "source": "generator",
      "page_item_url": "apartments-near-el-paso-international-airport",
      "search_query": "apartments near El Paso International Airport",
      "category": "Transit",
      "h1_title": "Apartments Near El Paso International Airport",
      "h2_subtitle": "Discover convenient living close to El Paso International Airport at Shadow Ridge Apartments. Enjoy modern comforts and easy airport access.",
      "page_copy": "Shadow Ridge Apartments is your gateway to convenient living just a short distance from El Paso International Airport. Perfect for frequent travelers or airport employees, our community offers easy access to this major transportation hub while providing a serene home environment in the heart of El Paso.\n\nChoose from our range of well-appointed one, two, or three-bedroom apartments, each featuring modern amenities like washers and dryers, plus access to a sparkling pool and fitness center. The vibrant yet tranquil setting of Shadow Ridge Apartments ensures that all your needs are met, combining the convenience of being near the airport with the comfort of a welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019cfb47-0448-7369-b106-f37aa20ab897",
        "storage_key": "property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near El Paso International Airport",
      "seo_description": "Explore Shadow Ridge Apartments near El Paso International Airport, offering easy access and modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5211"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-Y160YX6ESQ"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151663"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/shadow-ridge-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-58W2NZVJ"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165624/019d1bd9-9f83-766b-bce5-b6695f5c370c.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40342481553"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "31db7887-9934-4b5c-9f0a-a25bb9032708"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-645-0186"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6480cd2ffe1f0fae11cadb4b"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik1ZL2hMb08yblJ1SStLVzRGcW05T3c9PSIsInZhbHVlIjoiZ2NhWWFTeEUzcndnbm5hUzVnNGJ6QT09IiwibWFjIjoiMzQwMjE4YzY2NDgzM2RiNDU5OGJiZmQ5YjY1ZjU3YTRmMDQ2ZDU4MjczNzZhMTNiNDgyYTBiNjkyM2YxZmMyZSJ9"
    }
  ],
  "custom_qb_id": "5211",
  "custom_ga4_id": "G-Y160YX6ESQ",
  "custom_repli_id": "10041151663",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/shadow-ridge-apartments/register/",
  "custom_google_gtm_id": "GTM-58W2NZVJ",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165624/019d1bd9-9f83-766b-bce5-b6695f5c370c.pdf",
  "custom_hubspot_company_id": "40342481553",
  "custom_rentgrata_property_id": "31db7887-9934-4b5c-9f0a-a25bb9032708",
  "custom_ppc_tracking_phone_number": "866-645-0186",
  "custom_residentboost_apartment_id": "6480cd2ffe1f0fae11cadb4b",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik1ZL2hMb08yblJ1SStLVzRGcW05T3c9PSIsInZhbHVlIjoiZ2NhWWFTeEUzcndnbm5hUzVnNGJ6QT09IiwibWFjIjoiMzQwMjE4YzY2NDgzM2RiNDU5OGJiZmQ5YjY1ZjU3YTRmMDQ2ZDU4MjczNzZhMTNiNDgyYTBiNjkyM2YxZmMyZSJ9"
};

export const generatedAt = '2026-08-27T21:36:39.015Z';
